import React, { Component, forwardRef } from "react";
import { connect } from "react-redux";
import { withRouter } from "../../../utils/withRouter";
import "react-toastify/dist/ReactToastify.css";
import { fill_action } from "../../../actions/common_action/fillList_action";
import { Tab, Nav } from "react-bootstrap";
import "react-datepicker/dist/react-datepicker.css";
import { ToastContainer, toast } from "react-toastify";
import Loader from "../../../utils/Loader";
import { responseError, toastError, toastSuccess, BASE_URL, categoryActionId, awardCategoryActionId, award_event_id, applicantTypeActionId, applicationTypeActionId, countryActionId, stateActionId, headers, applicantTypePricingActionId, pgViewChargesActionId } from "../../../utils/constants";
import Header from "../../../common_components/Header";
import Select from "react-select";
import Modal from "react-bootstrap/Modal";
import moment from "moment";
import { getApplicationFormDetails_action, insertUpdateApplicationForm_action, getApplicationPaymentDetails_action, getApplicationFormDefaultDetails_action, getApplicantPricing_action } from "../../../actions/applicationModule_action/applicationForm_action";
import { sendPaymentForm_action } from "../../../actions/payment_action/payment_action";
import DatePicker from 'react-datepicker';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import Resizer from "react-image-file-resizer";
import { Link, Element } from "react-scroll";
import { getAwardQuerywithAnswerComment_action, insertUpdateAwardAnswer_action } from "../../../actions/common_action/awardQuery_action";
import JoditEditor from "jodit-react";
import { debounce, includes } from "lodash";
import DOMPurify from 'dompurify';
import { gstNoValidator, mobileNoValidator, notMendetoryEmailValidator, panNoValidator, tanNoValidator, websiteValidator } from "../../../utils/Validator";
import MobileHeader from "../../../common_components/mobileHeader";
import Footer from "../../../common_components/Footer";

const customStyles = {
    control: (provided) => ({
        ...provided,
        borderColor: "#c9c9c9", // Blue border color
        boxShadow: "none",
        "&:hover": {
            borderColor: "#80bdff", // Blue border color on hover
        },
    }),
    multiValue: (provided) => ({
        ...provided,
        borderRadius: "14px",
        padding: "4px",
        backgroundColor: "#00BCD4", // Blue background color for selected value
    }),
    multiValueLabel: (provided) => ({
        ...provided,
        color: "white", // Text color for selected value
        fontSize: "12px",
    }),
    multiValueRemove: (provided) => ({
        ...provided,
        color: "white",
        "&:hover": {
            backgroundColor: "#00BCD4",
            color: "#fff", // Blue border color on hover
        }, // Remove icon color for selected value
    }),
};
const joditConfig = {
    height: 400,
    buttons: [
        'bold',
        'strikethrough',
        'underline',
        'italic', '|',
        'ul',
        'ol', '|',
        'outdent', 'indent', '|',
        'font',
        'fontsize',
        'brush',
        'paragraph', '|',
        'align',
        'fullsize',
        "undo",
        "redo",
        "search",
        "|",
        {
            name: "more",
            iconURL: "https://cdn-icons-png.flaticon.com/512/130/130884.png", // Icon for "More Options"
            tooltip: "More Options",
            list: [
                'image',
                'video',
                'table',
                'link',
                "superscript",
                "subscript",
                "copyformat",
                "print",
                "hr", 'print',
                'copyformat',
            ],
        },
    ],
    toolbarAdaptive: false, // Prevents auto-hide for toolbar buttons
    toolbarSticky: false, // Keeps toolbar non-sticky
    toolbarButtonSize: "middle", // Sets the button size
    buttonsXS: ['bold',
        'image', '|',
        'brush',
        'paragraph', '|',
        'align', '|',
        'undo', 'redo', '|',
        'eraser',
        'dots', "more"], // Buttons for extra-small screens
    buttonsSM: ["bold", "italic", "underline", "link", "more"], // Buttons for small screens
    style: {
        toolbar: {
            display: "flex",
            justifyContent: "space-between", // Distributes toolbar items evenly
        },
    },
    dropdown: {
        display: "grid",
        gridTemplateColumns: "repeat(2, 1fr)", // Two columns
        gap: "10px", // Spacing between items
        padding: "10px", // Padding inside the dropdown
    },
    defaultStyle: 'font-family: Courier New; font-size: 14px;', // Set font family and default size
};
class ApplicationForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isInstructionsOpen: '', isUploadModal: false,
            isOpen: false,
            isLoading: true,
            Event_Name: '',
            category_name: '',
            eligibility_criteria: '',
            screening_process: '',
            categoryFillList: [], awardProfileFillList: [],
            pgViewChargesFillList: [],
            pgViewChargesModal: false,
            category_names: '',
            theme: '',
            important_instructions: '',
            applicationFormList: [],
            DeclarationData: '',
            DeclarationMessage: '',
            statusId: '',
            DeclarationFileName: '',
            DeclarationFileType: '',
            DeclarationFilePath: '',
            application_form_id: '',
            applicant_id: sessionStorage.getItem("user_id"),
            application_no: '',
            award_event_id: '',
            award_name: '',
            award_event_profile_id: '',
            declaration_file_path_db: '',
            download_Declaration_file_path: '',
            category_id: '',
            applicationBlanked: true,
            applicantTypeList: [],
            applicantTypeID: '',
            paymentType: '',
            is_paid: 1,
            sme_certificate_FileName: '',
            sme_certificate_FileType: '',
            sme_certificate_FilePath: '',
            sme_certificate_file_path: null,
            download_SME_Certificate_file_path: '',
            applicantTypeName: '',
            countryList: '',
            countryId: '',
            countryIdErr: '',
            stateName: '',
            stateErr: '',
            stateList: [],
            tempStateList: [],
            isDisplayStateList: false,
            cityName: '',
            CityNameErr: '',
            isDisplayCityList: '',
            pinCode: '',
            pincodeErr: '',
            isCollapse: false,
            isAplicationIsPaid: false,
            show: false,
            applicantPricingList: [],
            status_name: '',

            orderNo: '',
            paidAmount: '',
            //query
            questionQuerydata: [],
            answerQuerydata: [],
            commentQuerydata: [],
            queryPostContent: '',
            question_id: '',
            answer_id: '',
            isReplyMode: false,
            isOpen2: false,
            applicantTypeIDErr: '',
            isIncomplete: false,
            applicationEndDate: '',
            isApplicationDatePassed: false,
            SME_CertificateErr: '',
            is_gst_applicable: null,
        };
        this.navPayment = this.navPayment.bind(this);
        this.debouncedUpdateState = {};
        ['queryPostContent'].forEach(field => {
            this.debouncedUpdateState[field] = debounce(this.updateState.bind(this, field), 1000);
        });
    }


    componentDidMount() {
        const { user_id, awardProfileFillList, application_form_id } = this.state;
        this.getFillList(categoryActionId, user_id, "", "");
        this.getFillList(countryActionId, user_id, "", "");
        this.getFillList(awardCategoryActionId, user_id, "", award_event_id);
        this.getFillList(applicationTypeActionId, user_id, "", "")
        this.getFillList(applicantTypePricingActionId, user_id, "", "")
        this.getFillList(pgViewChargesActionId, user_id, "", "")

        if (JSON.parse(sessionStorage.getItem("AwardsUserLoginData")) == null) {
            setTimeout(() => {
                this.props.navigate("/login");
            }, 500);
        }

        setTimeout(() => {
            const role_id = JSON.parse(sessionStorage.getItem("AwardsUserLoginData"))?.role_id;
            if (role_id == 1) {
                this.props.navigate('/adminDashboard')
            } else if (role_id == 2) {
                this.props.navigate('/juryDashboard')
            } else if (role_id == 3) {
                this.props.navigate('/adminDashboard')
            }
        }, 10);
        var param = this.props.params != '' && Object.keys(this.props.params).length != 0 && this.props.params != undefined && this.props.params != null ? this.props.params : null
        var status = param != null ? param.status != undefined && param.status != '' && param.status != null ? param.status : null : null

        this.setState({
            user_id: sessionStorage.getItem("user_id") || "",
            award_event_profile_id: this.props.location.state != null ? this.props.location.state.award_event_profile_id : sessionStorage.getItem("award_event_profile_id"),
            application_form_id: status == 'Success' ? application_form_id : (this.props.location.state != null ? this.props.location.state.application_form_id : null),
            // isOpen: status == 'Success' ? true : false
        }, () => {



            if (status == 'Invalid' || status == 'Failure') {
                toastError("A problem was occured at the time of processing your payment, Please try again later")
            } else if (status == 'Success') {
                // this.getPaymentDetails()
            }
            setTimeout(() => {
                this.getApplicationFormDefaultDetails(status)
            }, 2000);
        });

    }

    getFillList(value, user_id, keyword, keyvalue) {
        // this.setState({ isLoading: true });
        this.props
            .fill_action(
                value,
                user_id == "" || user_id == null ? null : user_id,
                keyword != "" ? keyword : null,
                keyvalue != "" ? keyvalue : null
            )
            .then((data) => {
                if (data.error != 1) {
                    if (value == categoryActionId) {
                        this.setState({
                            categoryFillList: data.data,
                        });
                    }
                    if (value == awardCategoryActionId) {
                        this.setState({
                            awardProfileFillList: data.data,
                        });
                    }
                    if (value == applicationTypeActionId) {
                        this.setState({
                            applicantTypeList: data.data,
                        });
                    }
                    if (value == stateActionId) {
                        this.setState({
                            stateList: data.data,
                            tempStateList: data.data,
                        })
                    }
                    if (value == countryActionId) {
                        this.setState({ countryList: data.data })
                    }
                    if (value == applicantTypePricingActionId) {
                        if (data.data != '') {
                            this.setState({ isAplicationIsPaid: data.data[0]['price'] != 0 ? true : false })
                        }
                    }
                    if (value == pgViewChargesActionId) {
                        this.setState({ pgViewChargesFillList: data.data })
                    }
                } else {
                    responseError(data);
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }
    togglePGCharges() {
        this.setState(prevState => ({
            pgViewChargesModal: !prevState.pgViewChargesModal
        }));
    }
    getApplicantPricing() {
        this.setState({ isLoading: true })
        const { award_event_profile_id, countryId, stateName, applicantTypeID } = this.state

        this.props.getApplicantPricing_action(award_event_profile_id, countryId, stateName, applicantTypeID)
            .then((data) => {
                if (data.error != 1) {
                    this.setState({ isLoading: false, applicantPricingList: data.data })
                }
                else {
                    this.setState({ isLoading: false })
                    responseError(data.msg);
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    getApplicationFormDefaultDetails(status) {
        this.setState({ isLoading: true })
        const { award_event_profile_id } = this.state

        this.props.getApplicationFormDefaultDetails_action(award_event_profile_id)
            .then((data) => {
                if (data.error != 1) {
                    if (data.applicationDate != "") {
                        const endDate = moment(data.applicationDate[0]["application_end_date"]).format('DD-MM-YYYY');
                        this.setState({
                            applicationEndDate: endDate,
                        });
                    }
                    if ((data.applicationCount[0].applicationCount == 4) && (data.application_form_id == '')) {
                        this.props.navigate('/applicantDashboard', {
                            state: { isMaxCountPopOpen: true }
                        })
                    } else {
                        if (data.InputFieldData != '' && data.SectionNameData != '') {
                            this.setState({ applicationBlanked: false })
                        } else {
                            this.setState({ applicationBlanked: true })
                        }
                        if (data.application_form_id != '') {
                            this.setState({ application_form_id: data.application_form_id[0]['application_form_id'] })
                        }
                        if (data.InstrunctionData != '') {
                            this.setState({
                                category_id: data.InstrunctionData[0]["category_id"],
                                category_name: data.InstrunctionData[0]["category_name"],
                                category_names: data.InstrunctionData[0]["category_names"],
                                theme: data.InstrunctionData[0]["theme"],
                                eligibility_criteria: data.InstrunctionData[0]["eligibility_criteria"],
                                screening_process: data.InstrunctionData[0]["screening_process"],
                                important_instructions: data.InstrunctionData[0]["important_instructions"],
                                award_event_id: data.InstrunctionData[0]["award_event_id"],
                                award_name: data.InstrunctionData[0]["award_name"],
                                award_event_profile_id: data.InstrunctionData[0]["award_event_profile_id"],
                                DeclarationData: data.InstrunctionData[0]["award_event_profile_declaration"],
                                DeclarationMessage: data.InstrunctionData[0]["declaration_message"],
                                is_gst_applicable: data.InstrunctionData[0]["is_gst_applicable"],
                            })
                            const { applicantTypeList } = this.state
                            const applicant_type_ids = data.InstrunctionData[0]["applicant_type_ids"] != null ? data.InstrunctionData[0]["applicant_type_ids"].split(',') : []
                            const applicantArray = []
                            applicant_type_ids.length > 0 && applicant_type_ids.map((item, i) => {
                                for (let i = 0; i < applicantTypeList.length; i++) {
                                    if (applicantTypeList[i]['applicant_type_id'] == item) {
                                        applicantArray.push(applicantTypeList[i])
                                    }
                                }
                            })
                            this.setState({ applicantTypeList: applicantArray })
                        }
                        const userLoginData = JSON.parse(sessionStorage.getItem("AwardsUserLoginData"));
                        const name = userLoginData ? userLoginData.user_name : '';
                        const EmailId = userLoginData ? userLoginData.email_address : '';
                        const mobileNo = userLoginData ? userLoginData.contact_no : '';

                        const finalArray = []
                        if (data.SectionNameData != '') {
                            data.SectionNameData.map((item) => {
                                if (data.InputFieldData != '') {
                                    const array = []
                                    for (let i = 0; i < data.InputFieldData.length; i++) {
                                        if (data.InputFieldData[i]['fieldname'].toLowerCase().includes('name of the applicant')) {
                                            data.InputFieldData[i]['applicant_response'] = name
                                        } else if (data.InputFieldData[i]['fieldname'].toLowerCase() == 'email') {
                                            data.InputFieldData[i]['applicant_response'] = EmailId
                                        } else {
                                            data.InputFieldData[i]['applicant_response'] = null
                                        }
                                        data.InputFieldData[i]['FileName'] = null
                                        data.InputFieldData[i]['FileType'] = null
                                        data.InputFieldData[i]['FilePath'] = null
                                        data.InputFieldData[i]['application_form_id'] = null
                                        data.InputFieldData[i]['application_no'] = null
                                        data.InputFieldData[i]['award_name'] = null
                                        data.InputFieldData[i]['application_status_id'] = 2
                                        if (item.award_event_profile_form_section_id == data.InputFieldData[i]['award_event_profile_form_section_id']) {
                                            if (data.OptionsData != '') {
                                                const optionData = []
                                                for (let j = 0; j < data.OptionsData.length; j++) {
                                                    if (data.InputFieldData[i]['award_event_profile_section_fields_id'] == data.OptionsData[j]['award_event_profile_section_fields_id']) {
                                                        if (data.InputFieldData[i]['controltype_Name'] == 'Dropdown - Multi-Select') {
                                                            const obj = {
                                                                label: data.OptionsData[j]['options'],
                                                                value: data.OptionsData[j]['options'],
                                                            }
                                                            optionData.push(obj)
                                                        } else if ((data.InputFieldData[i]['controltype_Name'] == 'Checkbox - Single-Select') || (data.InputFieldData[i]['controltype_Name'] == 'Checkbox - Multi-Select')) {
                                                            data.OptionsData[j]['isChecked'] = false
                                                            optionData.push(data.OptionsData[j])
                                                        } else {
                                                            optionData.push(data.OptionsData[j])
                                                        }
                                                    }
                                                }
                                                data.InputFieldData[i]['optionData'] = optionData
                                                array.push(data.InputFieldData[i])
                                            } else {
                                                array.push(data.InputFieldData[i])
                                            }
                                        }
                                    }
                                    if (array.length > 0) {
                                        array.sort((a, b) => a.seq_no - b.seq_no)
                                        finalArray.push({ section_name: item.section_name, seq_no: item.seq_no, array })
                                    }
                                } else {
                                    finalArray.push(item)
                                }
                            })
                        }
                        setTimeout(() => {
                            if (finalArray.length > 0) {
                                finalArray.sort((a, b) => a.seq_no - b.seq_no)
                                this.setState({ applicationFormList: finalArray }, () => {
                                    this.getApplicationFormDetails(status)
                                    this.getAwardQuerywithAnswerComment()
                                })
                            } else {
                                this.setState({ isLoading: false })
                            }
                        }, 200);
                    }
                }
                else {
                    this.setState({ isLoading: false })
                    responseError(data);

                }

            })
            .catch((err) => {
                console.log(err)
            })
    }
    toggleUploadModal() {
        this.setState(prevState => ({
            isUploadModal: !prevState.isUploadModal
        }));
    }
    getApplicationFormDetails(status) {
        const { applicationFormList, application_form_id, applicationEndDate } = this.state
        this.props.getApplicationFormDetails_action(application_form_id)
            .then((data) => {
                if (data.error != 1) {
                    applicationFormList.map((item) => {
                        for (let i = 0; i < item.array.length; i++) {
                            for (let j = 0; j < data.data.length; j++) {
                                if (item.array[i]['award_event_profile_section_fields_id'] == data.data[j]['award_event_profile_section_fields_id']) {
                                    item.array[i]['applicant_response'] = data.data[j]['applicant_response']
                                    item.array[i]['application_form_id'] = data.data[j]['application_form_id']
                                    item.array[i]['application_no'] = data.data[j]['application_no']
                                    item.array[i]['application_status_id'] = data.data[j]['application_status_id']
                                    if (data.data[j]['file_path'] != null) {
                                        item.array[i]['file_path'] = data.data[j]['file_path']
                                        const file = data.data[j]["file_path"].split(`${data.data[j]['application_form_id']}/`)
                                        item.array[i]['FileName'] = file[1]
                                    }
                                    if (item.array[i]['controltype_Name'] == 'Dropdown - Multi-Select') {
                                        const array = item.array[i]['applicant_response'] != null ? item.array[i]['applicant_response'].split(',') : []
                                        const finalArray = []
                                        if (item.array[i].optionData != undefined) {
                                            for (let k = 0; k < item.array[i].optionData.length; k++) {
                                                if (array.includes(item.array[i].optionData[k]['label'])) {
                                                    finalArray.push({
                                                        label: item.array[i].optionData[k]['label'],
                                                        value: item.array[i].optionData[k]['label'],
                                                    })
                                                }
                                            }
                                        }
                                        item.array[i]['Multi_Select_value'] = finalArray
                                    }
                                    if (item.array[i]['controltype_Name'] == 'Checkbox - Single-Select') {
                                        if (item.array[i].optionData != undefined) {
                                            for (let k = 0; k < item.array[i].optionData.length; k++) {
                                                if (item.array[i].optionData[k]['award_event_profile_section_fields_options_id'] == data.data[j]['award_event_profile_section_fields_options_id']) {
                                                    item.array[i].optionData[k]['isChecked'] = true
                                                    item.array[i]['applicant_response'] = item.array[i].optionData[k]['options']
                                                } else {
                                                    item.array[i].optionData[k]['isChecked'] = false
                                                }
                                            }
                                        }
                                    }
                                    if (item.array[i]['controltype_Name'] == 'Checkbox - Multi-Select') {
                                        const array = item.array[i]['applicant_response'] != null ? item.array[i]['applicant_response'].split(' :&: ') : []
                                        if (item.array[i].optionData != undefined) {
                                            for (let k = 0; k < item.array[i].optionData.length; k++) {
                                                if (array.includes(item.array[i].optionData[k]['options'])) {
                                                    item.array[i].optionData[k]['isChecked'] = true
                                                } else {
                                                    item.array[i].optionData[k]['isChecked'] = false
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    })
                    this.setState({ applicationFormList: applicationFormList }, () => {
                        if (data.hdrdata != '') {
                            if (data.hdrdata[0]["declaration_file_path"] != null && data.hdrdata[0]["declaration_file_path"] != '') {
                                const file = data.hdrdata[0]["declaration_file_path"].split(`${data.hdrdata[0]['application_form_id']}/`)
                                const displayFile = data.hdrdata[0]["declaration_file_path"].split('.')
                                this.setState({
                                    DeclarationFileName: file[1],
                                    download_Declaration_file_path: displayFile[1] + '.' + displayFile[2],
                                })
                            }
                            if (data.hdrdata[0]["sme_certificate_file_path"] != null && data.hdrdata[0]["sme_certificate_file_path"] != '') {
                                const file = data.hdrdata[0]["sme_certificate_file_path"].split(`${data.hdrdata[0]['application_form_id']}/`)
                                const displayFile = data.hdrdata[0]["sme_certificate_file_path"].split('.')
                                this.setState({
                                    sme_certificate_FileName: file[1],
                                    download_SME_Certificate_file_path: displayFile[1] + '.' + displayFile[2],
                                })
                            }
                            const currentDate = moment().format('DD-MM-YYYY')
                            const isExpired = new Date(applicationEndDate.split("-").reverse().join("-")) < new Date(currentDate.split("-").reverse().join("-"));
                            this.setState({
                                statusId: data.hdrdata[0]['application_status_id'],
                                application_form_id: data.hdrdata[0]['application_form_id'],
                                application_no: data.hdrdata[0]['application_no'],
                                declaration_file_path_db: data.hdrdata[0]["declaration_file_path"],
                                sme_certificate_file_path: data.hdrdata[0]["sme_certificate_file_path"],
                                applicantTypeID: data.hdrdata[0]["applicant_type_id"],
                                applicantTypeName: data.hdrdata[0]["applicant_type"],
                                status_name: data.hdrdata[0]["status_name"],
                                paymentType: data.hdrdata[0]["payment_type"],
                                is_paid: data.hdrdata[0]["is_paid"],
                                is_gst_applicable: data.hdrdata[0]["is_gst_applicable"],
                                cityName: data.hdrdata[0]["city"],
                                stateName: data.hdrdata[0]["state"],
                                countryId: data.hdrdata[0]["country_id"],
                                pinCode: data.hdrdata[0]["pincode"],
                                isIncomplete: data.hdrdata[0]["isIncomplete"],
                                outstanding: data.hdrdata[0]["outstanding"],
                                isApplicationDatePassed: isExpired
                            }, () => {

                                if (status == 'Success') {
                                    this.getPaymentDetails()
                                }
                            })
                            if (data.hdrdata[0]["country_id"] == 91) {
                                this.getFillList(stateActionId, '', data.hdrdata[0]["country_id"], '')
                            }
                            this.getFillList(28, data.hdrdata[0]['award_event_profile_id'], data.hdrdata[0]["applicant_type_id"], award_event_id);
                        }
                    })
                    this.setState({ isLoading: false })
                }
                else {
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    getPaymentDetails() {
        const { award_event_profile_id, application_form_id, } = this.state
        this.props.getApplicationPaymentDetails_action(application_form_id, award_event_profile_id)
            .then((data) => {
                if (data.error != 1) {
                    this.setState({
                        orderNo: data.data[0].cc_order_id,
                        paidAmount: data.data[0].amount,
                        isOpen: true
                    })
                }
            })
    }

    handleSaveAsDraft(paymentType) {
        const { applicationFormList, application_form_id, applicant_id, application_no, award_event_id, award_event_profile_id, DeclarationFileName, DeclarationFileType, DeclarationFilePath, declaration_file_path_db, applicantTypeID, applicantTypeList, is_paid, is_gst_applicable, sme_certificate_FileName, sme_certificate_FileType, sme_certificate_FilePath, sme_certificate_file_path, applicantTypeName, award_name, cityName, stateName, countryId, pinCode } = this.state
        const array = []
        var isMendate = true
        return new Promise((resolve, reject) => {

            applicationFormList.map(data => {
                isMendate = data.array.every(obj => obj.is_mandatory ? (obj.applicant_response != '' && obj.applicant_response != null ? true : false) : true)
                data.array.map(item => {
                    if (item.controltype_Name == 'Checkbox - Single-Select') {
                        item.optionData.map((obj) => {
                            if (obj.isChecked) {
                                array.push(
                                    {
                                        award_event_profile_section_fields_id: item.award_event_profile_section_fields_id,
                                        award_event_profile_form_section_id: item.award_event_profile_form_section_id,
                                        applicant_response: null,
                                        award_event_profile_section_fields_options_id: obj.award_event_profile_section_fields_options_id,
                                        file_path: item.file_path,
                                        FileName: item.FileName,
                                        FilePath: item.FilePath,
                                        FileType: item.FileType,
                                    }
                                )
                            }
                        })
                    } else {
                        array.push({
                            award_event_profile_section_fields_id: item.award_event_profile_section_fields_id,
                            award_event_profile_form_section_id: item.award_event_profile_form_section_id,
                            applicant_response: item.applicant_response,
                            award_event_profile_section_fields_options_id: null,
                            file_path: item.file_path,
                            FileName: item.FileName,
                            FilePath: item.FilePath,
                            FileType: item.FileType,
                        })
                    }
                })
            })

            this.setState({ isLoading: true })
            this.props.insertUpdateApplicationForm_action(application_form_id, applicant_id, application_no, award_event_id, award_event_profile_id, 2, DeclarationFileName, DeclarationFileType, DeclarationFilePath, array, declaration_file_path_db, is_paid, applicantTypeID, applicantTypeName, null, is_gst_applicable, sme_certificate_FileName, sme_certificate_FileType, sme_certificate_FilePath, sme_certificate_file_path, award_name, cityName, stateName, countryId, pinCode)
                .then((data) => {
                    if (data.error != 1) {
                        if (paymentType == 'online') {
                            this.setState({ application_no: data.data[0]['application_no'] })
                            resolve(data.data)
                        } else {
                            toastSuccess("Submitted SuccessFully")
                            // this.getApplicationFormDefaultDetails()
                            this.setState({ isLoading: false, statusId: 1 })
                            setTimeout(() => {
                                this.props.navigate('/applicantDashboard', {
                                    state: { application_no: data.data[0]['application_no'] }
                                })
                            }, 1000);
                            // setTimeout(() => {
                            //     window.location.reload()
                            // }, 1000);
                        }
                    }
                    else {
                        this.setState({ isLoading: false })
                        toastError(data.msg)
                    }
                })
                .catch((err) => {
                    console.log(err)
                })
        })
    }

    handleSubmit(paymentType) {
        const { applicationFormList, application_form_id, applicant_id, application_no, award_event_id, award_event_profile_id, DeclarationFileName, DeclarationFileType, DeclarationFilePath, declaration_file_path_db, applicantTypeID, applicantTypeList, is_paid, is_gst_applicable, sme_certificate_FileName, sme_certificate_FileType, sme_certificate_FilePath, sme_certificate_file_path, applicantTypeName, award_name, cityName, CityNameErr, stateName, stateErr, countryId, countryIdErr, pinCode, pincodeErr, isAplicationIsPaid, isIncomplete } = this.state
        // this.inputValidate()
        return new Promise((resolve, reject) => {
            const array = []
            var isMendate = true
            applicationFormList.map(data => {
                const mendateArray = data.array.filter(item => item.is_mandatory && item.controltype_Name != "File Upload")
                const mendateFileArray = data.array.filter(item => item.is_mandatory && item.controltype_Name == "File Upload")
                const checkCondition1 = mendateArray.every(obj => obj.applicant_response != null)
                const checkCondition2 = mendateFileArray.every(obj => obj.FileName != null)

                if (!checkCondition1 || !checkCondition2) {
                    isMendate = false
                }
                data.array.map(item => {
                    if (item.controltype_Name == 'Checkbox - Single-Select') {
                        item.optionData.map((obj) => {
                            if (obj.isChecked) {
                                array.push(
                                    {
                                        award_event_profile_section_fields_id: item.award_event_profile_section_fields_id,
                                        award_event_profile_form_section_id: item.award_event_profile_form_section_id,
                                        applicant_response: null,
                                        award_event_profile_section_fields_options_id: obj.award_event_profile_section_fields_options_id,
                                        file_path: item.file_path,
                                        FileName: item.FileName,
                                        FilePath: item.FilePath,
                                        FileType: item.FileType,
                                    }
                                )
                            }
                        })
                    } else {
                        array.push({
                            award_event_profile_section_fields_id: item.award_event_profile_section_fields_id,
                            award_event_profile_form_section_id: item.award_event_profile_form_section_id,
                            applicant_response: item.applicant_response,
                            award_event_profile_section_fields_options_id: null,
                            file_path: item.file_path,
                            FileName: item.FileName,
                            FilePath: item.FilePath,
                            FileType: item.FileType,
                        })
                    }
                })
            })

            if (isMendate) {
                if (cityName != '' && cityName != null && stateName != '' && stateName != null && countryId != '' && countryId != null) {
                    if (DeclarationFileName != '') {
                        // const confirmed = window.confirm(
                        //     "Do you really want to submit Application Form ?"
                        // );
                        // if (confirmed) {
                        this.setState({ isLoading: true })
                        this.props.insertUpdateApplicationForm_action(application_form_id, applicant_id, application_no, award_event_id, award_event_profile_id, 3, DeclarationFileName, DeclarationFileType, DeclarationFilePath, array, declaration_file_path_db, is_paid, applicantTypeID, applicantTypeName, paymentType, is_gst_applicable, sme_certificate_FileName, sme_certificate_FileType, sme_certificate_FilePath, sme_certificate_file_path, award_name, cityName, stateName, countryId, pinCode, isAplicationIsPaid, isIncomplete)
                            .then((data) => {
                                if (data.error != 1) {
                                    if (paymentType == 'online' && !isIncomplete) {
                                        resolve(data.data)
                                    } else {
                                        toastSuccess("Submitted SuccessFully")
                                        this.setState({ isLoading: false, statusId: 3, isOpen2: false })
                                        setTimeout(() => {
                                            this.props.navigate('/applicantDashboard', {
                                                state: { application_no: data.data[0]['application_no'] }
                                            })
                                        }, 1000);
                                    }
                                }
                                else {
                                    this.setState({ isLoading: false })
                                    toastError(data.msg)
                                }
                            })
                            .catch((err) => {
                                console.log(err)
                            })
                        // } else {
                        //     this.setState({ isLoading: false })
                        //     reject(true)
                        // }
                    } else {
                        this.setState({ isLoading: false })
                        toastError("Please Upload Declaration Form!")
                    }
                } else {
                    this.setState({ isLoading: false, })
                    toastError("Please enter mandatory fields!")
                }
            } else {
                this.setState({ isLoading: false, })
                toastError("Please enter mandatory fields!")
            }
        })
    }

    toggleInstructionDetails() {
        this.setState(prevState => ({
            isInstructionsOpen: !prevState.isInstructionsOpen
        }))
    }

    generatePdf = () => {
        const input = this.state.DeclarationData
        const pdfContainer = document.createElement('div');
        pdfContainer.style.width = '190mm';  // Adjust for padding
        pdfContainer.innerHTML = input;
        document.body.appendChild(pdfContainer); // Append to body for rendering

        // Convert HTML to canvas using html2canvas
        html2canvas(pdfContainer, { scale: 2 }).then((canvas) => {
            const imgData = canvas.toDataURL('image/png');
            const pdf = new jsPDF('p', 'mm', 'a4');
            const imgWidth = 190; // A4 width minus padding
            const pageHeight = 297; // A4 height
            const imgHeight = (canvas.height * imgWidth) / canvas.width;
            const padding = 10; // Padding from each side

            let heightLeft = imgHeight;
            let position = padding; // Start from padding

            pdf.addImage(imgData, 'PNG', padding, position, imgWidth, imgHeight); // Start content after padding
            heightLeft -= pageHeight;

            // Add new pages if content overflows
            while (heightLeft > 0) {
                position = heightLeft - imgHeight;
                pdf.addPage();
                pdf.addImage(imgData, 'PNG', padding, position, imgWidth, imgHeight); // Maintain padding
                heightLeft -= pageHeight;
            }

            pdf.save('Declaration_Form.pdf');
            document.body.removeChild(pdfContainer);  // Clean up the DOM after generation
        });
    };

    handleInput(event, controltype_Name, seq_no, index, checkboxValue) {
        const { applicationFormList } = this.state

        applicationFormList.forEach((data) => {
            if (data.seq_no == seq_no) {
                data.array.map((item, i) => {
                    if (i === index) {
                        if ('Checkbox - Single-Select' == controltype_Name) {
                            item.optionData.map((obj) => {
                                if (checkboxValue == obj.options) {
                                    if (event) {
                                        item.applicant_response = checkboxValue
                                        obj.isChecked = true
                                    } else {
                                        item.applicant_response = null
                                        obj.isChecked = false
                                    }
                                } else {
                                    obj.isChecked = false
                                }
                            })
                        } else if ('Checkbox - Multi-Select' == controltype_Name) {
                            item.optionData.map((obj) => {
                                if (checkboxValue == obj.options) {
                                    if (event) {
                                        obj.isChecked = true
                                    } else {
                                        obj.isChecked = false
                                    }
                                }
                            })
                            const array = item.optionData.filter(data => data.isChecked)
                            const finalArray = []
                            if (array != '') {
                                array.map((obj) => {
                                    finalArray.push(obj.options)
                                })
                            }
                            // console.log("finalArray.join()--->",finalArray.join(' :&: '))
                            item.applicant_response = finalArray.join(' :&: ')
                        } else if ('Text Box - AlphaNumeric' == controltype_Name) {
                            item.applicant_response = event
                            if (item.fieldname.toLowerCase().includes('gst no')) {
                                const gstErr = gstNoValidator(event)
                                item.applicationErr = gstErr
                            } else if (item.fieldname.toLowerCase().includes('pan no')) {
                                const panErr = panNoValidator(event)
                                item.applicationErr = panErr
                            } else if (item.fieldname.toLowerCase().includes('tan no')) {
                                const tanErr = tanNoValidator(event)
                                item.applicationErr = tanErr
                            }
                        } else if ("Dropdown - Multi-Select" == controltype_Name) {
                            const data = []
                            item.Multi_Select_value = event
                            if (event != '') {
                                event.map(item => data.push(item.value))
                                item.applicant_response = data.join()
                            } else {
                                item.applicant_response = null
                            }
                        } else if ('Dropdown - Single-Select' == controltype_Name) {
                            item.applicant_response = event
                        } else if ('Text Box - Numeric' == controltype_Name) {
                            item.applicant_response = event.replace(/[^0-9]/g, '')
                        } else if ('Date Picker' == controltype_Name) {
                            item.applicant_response = event
                        } else if ('Multiline Text Box' == controltype_Name) {
                            item.applicant_response = event
                        } else if ('Text Box - Email' == controltype_Name) {
                            item.applicant_response = event
                            const emailErr = notMendetoryEmailValidator(event)
                            item.applicationErr = emailErr
                        } else if ('Text Box - Website' == controltype_Name) {
                            item.applicant_response = event
                            const websiteErr = websiteValidator(event)
                            item.applicationErr = websiteErr
                        } else if ('Text Box - Phone Number' == controltype_Name) {
                            item.applicant_response = event.replace(/[^0-9]/g, '')
                            const mobileErr = mobileNoValidator(event)
                            item.applicationErr = mobileErr
                        } else if ('Text Box - Decimal' == controltype_Name) {
                            console.log("Decimal-->", event)
                            item.applicant_response = event.replace(/[^0-9.]/g, '')
                        }
                    }
                })
            }
        })
        this.setState({ applicationFormList: applicationFormList })
    }


    onDeclarationFormFilePick = async (e, file) => {
        e.preventDefault()
        const { formFile, trcFile, declarationFile, formFileType, declarationFileType, trcFileType } = this.state
        var image = '';
        if (file[0]['size'] > 5242880) {
            toast.error('File size more than 5MB are not allow.', {
                position: "top-center",
                theme: 'colored',
                autoClose: 3000,
                hideProgressBar: true,
            })

        } else {
            if (file[0]['name'].toString().toLowerCase().includes('.pdf')
            ) {
                if (file[0]['name'].includes('pdf')) {
                    image = await this.onPdfSelect(file[0]);
                }
                else {
                    image = await this.resizeFile(file[0]);
                }

                this.setState({ DeclarationFilePath: image, DeclarationFileName: file[0]['name'] })
                const fileType = file[0]['type']
                var fileTypeList;
                if (fileType.includes("/")) {
                    fileTypeList = fileType.split("/")

                }
                this.setState({ DeclarationFileType: fileTypeList.length > 0 ? fileTypeList[1] : '' })
            } else {
                toast.error('Only .pdf files are allowed', {
                    position: "top-center",
                    theme: 'colored',
                    autoClose: 3000,
                    hideProgressBar: true,
                })
            }
        }
    }

    onSME_CertificateFilePick = async (e, file) => {
        e.preventDefault()
        const { formFile, trcFile, declarationFile, formFileType, declarationFileType, trcFileType } = this.state
        var image = '';
        if (file[0]['size'] > 5242880) {
            toast.error('File size more than 5MB are not allow.', {
                position: "top-center",
                theme: 'colored',
                autoClose: 3000,
                hideProgressBar: true,
            })

        } else {
            if (file[0]['name'].toString().toLowerCase().includes('.pdf')
            ) {
                if (file[0]['name'].includes('pdf')) {
                    image = await this.onPdfSelect(file[0]);
                }
                else {
                    image = await this.resizeFile(file[0]);
                }

                this.setState({ sme_certificate_FilePath: image, sme_certificate_FileName: file[0]['name'], SME_CertificateErr: '' })

                const fileType = file[0]['type']
                var fileTypeList;
                if (fileType.includes("/")) {
                    fileTypeList = fileType.split("/")

                }
                this.setState({ sme_certificate_FileType: fileTypeList.length > 0 ? fileTypeList[1] : '' })
            } else {
                toast.error('Only .pdf files are allowed', {
                    position: "top-center",
                    theme: 'colored',
                    autoClose: 3000,
                    hideProgressBar: true,
                })
            }
        }
    }

    inputValidate() {
        const { applicantTypeID, pinCode, countryId, stateName, cityName, sme_certificate_FileName, SME_CertificateErr } = this.state
        if (applicantTypeID == "" || applicantTypeID == null) {
            this.setState({ applicantTypeIDErr: 'Please Select Applicant Type', isDisplayCityList: false })
        }
        if (cityName == "" || cityName == null) {
            this.setState({ CityNameErr: 'Please Enter City', isDisplayCityList: false })
        }
        if (stateName == "" || stateName == null) {
            this.setState({ stateErr: 'Please Enter State' })
        }
        if (countryId == "" || countryId == null) {
            this.setState({ countryIdErr: 'Please Select Country' })
        }
        if (sme_certificate_FileName == "" || sme_certificate_FileName == null) {
            this.setState({ SME_CertificateErr: 'Please Upload MSME Certificate' })
        }
        if (pinCode == "" || pinCode == null) {
            if (countryId == '91' || countryId == '') {
                this.setState({ pincodeErr: 'Please Enter Pincode' })
            } else {
                this.setState({ pincodeErr: 'Please Enter ZipCode' })
            }
        }

    }

    onFilePick = async (e, file, controltype_Name, seq_no, index, file_format, max_size) => {
        e.preventDefault()
        const { applicationFormList } = this.state
        var image = '';
        applicationFormList.forEach((data) => {
            if (data.seq_no == seq_no) {
                data.array.map(async (item, i) => {
                    if (i === index) {
                        // const size = Number(max_size.match(/\d+/)[0]) * 1048576
                        const size = max_size * 1048576
                        if (file[0]['size'] > size) {
                            toast.error(`File size more than ${max_size} MB are not allow.`, {
                                position: "top-center",
                                theme: 'colored',
                                autoClose: 3000,
                                hideProgressBar: true,
                            })

                        } else {
                            const fileTypeDataList = file_format.split(',')
                            var fileTypeFlag = false
                            fileTypeDataList.map((item) => {
                                if (file[0]['name'].toString().trim().toLowerCase().includes(item.toLowerCase().trim())) {
                                    fileTypeFlag = true
                                }
                            })
                            if (fileTypeFlag) {
                                const base64Data = await this.convertToBase64(file[0]);
                                const fileType = file[0]['type']
                                var fileTypeList;
                                if (fileType.includes("/")) {
                                    fileTypeList = fileType.split("/")

                                }
                                item.FileName = file[0]['name']
                                item.FilePath = base64Data
                                item.FileType = fileTypeList != undefined ? fileTypeList.length > 0 ? fileTypeList[1] : null : file_format
                                // this.setState({ DeclarationFileType: fileTypeList.length > 0 ? fileTypeList[1] : '' })
                            } else {
                                toast.error(`Only ${file_format} files are allowed`, {
                                    position: "top-center",
                                    theme: 'colored',
                                    autoClose: 3000,
                                    hideProgressBar: true,
                                })
                            }
                        }
                    }
                })
            }
        })
        setTimeout(() => {
            this.setState({ applicationFormList: applicationFormList })
        }, 100);
    }

    removeFile(controltype_Name, seq_no, index, checkboxValue) {
        const { applicationFormList } = this.state

        applicationFormList.forEach((data) => {
            if (data.seq_no == seq_no) {
                data.array.map((item, i) => {
                    if (i === index) {
                        if (controltype_Name == item.controltype_Name) {
                            item.FileName = null
                            item.FilePath = null
                            item.FileType = null
                            item.file_path = null
                        }
                    }
                })
            }
        })
        this.setState({ applicationFormList: applicationFormList })
    }

    convertToBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });
    }

    onPdfSelect = (file) =>
        new Promise((resolve) => {
            let base64;
            let fileReader = new FileReader();
            fileReader.onload = function (fileLoadedEvent) {
                base64 = fileLoadedEvent.target.result;
                resolve(base64);
            };
            fileReader.readAsDataURL(file);
        });

    resizeFile = (file) =>
        new Promise((resolve) => {
            Resizer.imageFileResizer(
                file,
                500,
                600,
                'JPEG',
                80,
                0,
                (uri) => {
                    resolve(uri);
                },
                "base64",
                300,
                300,
            );
        });

    removeDeclarationFile() {
        this.setState({
            DeclarationFileName: '',
            DeclarationFileType: '',
            DeclarationFilePath: '',
            download_Declaration_file_path: '',
            declaration_file_path_db: null,
        })
    }

    remove_SME_certificate() {
        this.setState({
            sme_certificate_FileName: '',
            sme_certificate_FileType: '',
            sme_certificate_FilePath: '',
            sme_certificate_file_path: null,
            download_SME_Certificate_file_path: null
        })
    }

    onCountryId(e) {
        const { } = this.state
        this.setState({ countryId: e.target.value, countryIdErr: '', stateName: '' })
        if (e.target.value == '91') {
            this.getFillList(stateActionId, '', e.target.value, '')
        }

        if (e.target.value != 91) {
            this.setState({
                cityName: '',
                stateName: '',
                pincode: '',
                isDisplayStateList: false,
                isDisplayCityList: false,
            })
        } else {
            // this.setState({
            //     CityNameErr: '',
            //     stateErr: '',
            //     pincodeErr: '',
            // })
        }
    }

    // search State
    onStateSearch(e) {
        const { stateList, tempStateList, countryId } = this.state
        if (countryId == '91' || countryId == '') {
            if (e.target.value != '') {
                var searchStateList = tempStateList.filter(data => {
                    return (
                        data
                            .state_name
                            .toLowerCase()
                            .includes(e.target.value.toLowerCase())
                    )
                })
                this.setState({
                    stateName: e.target.value,
                    stateErr: '',
                    tempStateList: searchStateList,
                    isDisplayStateList: true
                })
            } else {
                this.setState({
                    stateName: e.target.value,
                    stateErr: '',
                    tempStateList: stateList,
                    isDisplayStateList: false
                })
            }
        } else {
            this.setState({
                stateName: e.target.value,
                isDisplayStateList: false,
                stateErr: '',
            })
        }
    }
    // render State
    renderStateList() {
        const { tempStateList } = this.state
        return (
            <ul class="list-group pincode-drop" style={{ position: 'absolute', zIndex: 100, }}>
                {

                    tempStateList.length > 0 && tempStateList.map(data => (
                        <li class="list-group-item" key={Math.random()}
                            onClick={() => this.mainStateListData(data)}
                        >{data.state_name}</li>
                    ))

                }
            </ul>
        )
    }
    mainStateListData(data) {
        const { SameAsAbove } = this.state
        this.setState({ stateName: data.state_name, isDisplayStateList: false, stateErr: '' })
    }

    // search city
    onCitytSearch(e) {
        const { cityList, tempCityList, billTempCityList, cityName, countryId, SameAsAbove } = this.state
        if (countryId == '91' || countryId == '') {
            if (e.target.value != '') {
                var searchCityList = tempCityList.filter(data => {
                    return (
                        data
                            .CityName
                            .toLowerCase()
                            .includes(e.target.value.toLowerCase())
                    )
                })
                this.setState({
                    cityName: e.target.value.replace(/[^a-zA-Z ]/g, '').split(' ')
                        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                        .join(' '),
                    CityNameErr: '',
                    tempCityList: searchCityList,
                    isDisplayCityList: true
                })
            } else {
                this.setState({
                    cityName: e.target.value.replace(/[^a-zA-Z ]/g, '').split(' ')
                        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                        .join(' '),
                    tempCityList: cityList,
                    isDisplayCityList: false
                })
            }
        } else {
            this.setState({
                cityName: e.target.value.replace(/[^a-zA-Z ]/g, '').split(' ')
                    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                    .join(' '),
                isDisplayCityList: false,
                CityNameErr: '',
            })
        }
    }

    // render city
    renderCityList() {
        const { tempCityList } = this.state
        return (
            <ul class="list-group pincode-drop" style={{ position: 'absolute', zIndex: 100 }}>
                {
                    tempCityList.length > 0 && tempCityList.map(data => (
                        <li class="list-group-item" key={Math.random()}
                            onClick={() => this.mainCityListData(data)}
                        >{data.CityName}</li>
                    ))
                }
            </ul>
        )
    }

    mainCityListData(data) {
        const { SameAsAbove } = this.state
        this.setState({ cityName: data.CityName, isDisplayCityList: false, CityNameErr: '' })
    }

    isModal(paymentType) {
        const { applicationFormList, cityName, stateName, countryId, show, DeclarationFileName, isIncomplete, SME_CertificateErr, applicantTypeName, sme_certificate_FileName } = this.state
        var isMendate = true
        this.inputValidate()
        const applicationValidationList = []
        applicationFormList.map(data => {
            const mendateArray = data.array.filter(item => item.is_mandatory && item.controltype_Name != "File Upload")
            const mendateFileArray = data.array.filter(item => item.is_mandatory && item.controltype_Name == "File Upload")
            const checkCondition1 = mendateArray.every(obj => obj.applicant_response != null && obj.applicant_response != '')
            const checkCondition2 = mendateFileArray.every(obj => obj.FileName != null && obj.FileName != '')
            mendateArray.filter(obj => obj.applicationErr != '' && obj.applicationErr != undefined).map(item => applicationValidationList.push(item))
            mendateArray.map(item => {
                item.submitValidation = true
            })
            mendateFileArray.map(item => {
                item.submitValidation = true
            })
            if (!checkCondition1 || !checkCondition2) {
                isMendate = false
            }
        })
        this.setState({ applicationFormList: applicationFormList })
        console.log("applicantTypeName.toLowerCase() == 'msme organization'", applicantTypeName.toLowerCase() == 'msme organization')
        if (isMendate) {
            if (cityName != '' && cityName != null && stateName != '' && stateName != null && countryId != '' && countryId != null && (applicantTypeName.toLowerCase() == 'msme organization' ? sme_certificate_FileName != '' && sme_certificate_FileName != null : true)) {
                if (applicationValidationList.length == 0) {
                    if (DeclarationFileName != '') {
                        if (paymentType == 'online' && !isIncomplete) {
                            this.getApplicantPricing()
                            this.setState({ show: !show, paymentType: paymentType })
                        } else {
                            this.setState({ isOpen2: true, paymentType: paymentType })
                        }
                    } else {
                        this.setState({ isLoading: false })
                        toastError("Please upload declaration form!")
                    }
                } else {
                    this.setState({ isLoading: false })
                    toastError("Please provide correct data!")
                }
            } else {
                this.setState({ isLoading: false, })
                toastError("Please enter mandatory fields!")
            }
        } else {
            this.setState({ isLoading: false, })
            toastError("Please enter mandatory fields!")
        }
    }

    navPayment(e) {
        e.preventDefault()
        const { applicantPricingList, award_event_profile_id, show, statusId, application_form_id } = this.state
        this.setState({ isLoading: true })
        // if (statusId == '') {
        this.handleSaveAsDraft('online').then(desRes => {
            var id = desRes.length > 0 ? desRes[0].application_form_id != undefined ? desRes[0].application_form_id : '' : ''
            this.setState({ application_form_id: id, show: false })
            var toPay = applicantPricingList.length > 0 ? applicantPricingList[0]['grand_total'] : 0
            this.props.sendPaymentForm_action(award_event_profile_id, id, toPay, parseInt(this.state.countryId) == 91 ? 'INR' : 'USD', [], 'applicationForm')
                .then((data) => {
                    if (data.error != 1) {
                        if (data != null) {
                            this.setState({ paymentLink: data.data }, () => {
                                window.location.replace(data.data)

                            })
                        }
                    }
                    else {
                        this.setState({ isLoading: false })
                        toastError('There is some problem. Please try again later!')
                    }
                })
                .catch((err) => {
                    console.log(err)
                })
        }).catch(desErr => {
        })
        // } else {
        //     var toPay = applicantPricingList.length > 0 ? applicantPricingList[0]['grand_total'] : 0
        //     this.props.sendPaymentForm_action(award_event_profile_id, application_form_id, toPay, parseInt(this.state.countryId) == 91 ? 'INR' : 'USD', [], 'applicationForm')
        //         .then((data) => {
        //             if (data.error != 1) {
        //                 if (data != null) {
        //                     this.setState({ paymentLink: data.data }, () => {
        //                         window.location.replace(data.data)

        //                     })
        //                 }
        //             }
        //             else {
        //                 this.setState({ isLoading: false })
        //                 toastError('There is some problem. Please try again later!')
        //             }
        //         })
        //         .catch((err) => {
        //             console.log(err)
        //         })
        // }
    }
    getAwardQuerywithAnswerComment = () => {
        const { award_event_id, award_event_profile_id, application_form_id } = this.state;
        this.setState({ isLoading: true });
        this.props
            .getAwardQuerywithAnswerComment_action(award_event_id, award_event_profile_id, application_form_id, '')
            .then((data) => {
                if (data.error !== 1) {
                    const questionQuerydata = data.data[0];
                    const answerQuerydata = data.data[1];
                    const updatedQuestionQuerydata = questionQuerydata.filter(data => data.query_to == 1 && data.role_id != 2).map((question) => {
                        const matchingAnswers = answerQuerydata.filter(
                            (answer) => answer.question_id === question.question_id
                        );
                        return { ...question, answerQueryData: matchingAnswers };
                    });
                    this.setState({
                        questionQuerydata: updatedQuestionQuerydata,
                        // answerQuerydata,
                        isLoading: false,
                        currentpage: 1,
                    });
                } else {
                    this.setState({ isLoading: false });
                    responseError(data);
                }
            })
            .catch((e) => {
                console.log(e);
                this.setState({ isLoading: false });
            });

    }
    replyQuery(question_id) {
        const { queryPostContent, answer_id, application_form_id } = this.state;
        if (queryPostContent == '') {
            toastError('Kindly Fill Content')
        } else {
            const role_id = 4
            const queryTo = 3
            this.props.insertUpdateAwardAnswer_action(question_id, answer_id, queryPostContent, application_form_id, sessionStorage.getItem('user_name'), sessionStorage.getItem('email_address'), role_id, queryTo)
                .then((data) => {
                    if (data.error != 1) {
                        this.setState({ queryPostContent: '', isReplyMode: false, question_id: '' }, () => {
                            this.getAwardQuerywithAnswerComment();
                        })
                    } else {
                        toastError(data.msg)
                    }
                }).catch((e) => console.log(e))
        }
    }
    onReplyToggle(question_id) {
        if (this.state.isReplyMode) {
            this.setState({ isReplyMode: false, question_id: null, queryPostContent: '' })
        } else {
            this.setState({ isReplyMode: true, question_id: question_id })
        }
    }
    handleQueryEditor = (newContent, type) => {
        this.debouncedUpdateState[type](newContent);
    }
    updateState(field, value) {
        this.setState({ [field]: value });
    }

    handleViewFile = (base64String, fileName) => {
        // Extract MIME type and Base64 data
        const mimeType = base64String.split(';')[0].split(':')[1]; // Extract MIME type (e.g., 'image/png' or 'application/pdf')
        const byteCharacters = atob(base64String.split(',')[1]); // Extract Base64 content
        const byteNumbers = Array.from(byteCharacters).map(char => char.charCodeAt(0));
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: mimeType });

        // Create a URL for the Blob
        const fileURL = URL.createObjectURL(blob);

        if (mimeType.startsWith('image/') || mimeType === 'application/pdf') {
            // Open viewable files directly
            const newTab = window.open(fileURL, '_blank', 'noopener,noreferrer');
            if (newTab) {
                newTab.document.title = fileName; // Set the tab title to the file name
            }
        } else {
            // Download non-viewable files
            const link = document.createElement('a');
            link.href = fileURL;
            link.download = fileName; // Use the specific file name for the download
            link.click();
        }

        // Clean up the blob URL after the file action
        setTimeout(() => URL.revokeObjectURL(fileURL), 500);
    };

    render() {
        const { isInstructionsOpen, isUploadModal, isLoading, award_event_id, Event_Name, category_name, eligibility_criteria, applicantTypeList,
            screening_process, categoryFillList, category_names, theme, important_instructions, applicationFormList, DeclarationData, DeclarationMessage, statusId, DeclarationFileName, download_Declaration_file_path, category_id, download_SME_Certificate_file_path, applicantTypeName,
            award_event_profile_id, awardProfileFillList, award_name, applicationBlanked, applicantTypeID, plicantTypeList, sme_certificate_FileName, countryList, countryId, countryIdErr, stateName, stateErr, isDisplayStateList, cityName, CityNameErr,
            isDisplayCityList, pinCode, pincodeErr, isCollapse, isAplicationIsPaid, show, applicantPricingList, application_no, status_name, isIncomplete,
            //query
            questionQuerydata, answerQuerydata, commentQuerydata, queryPostContent, question_id, answer_id, isReplyMode, paymentType, applicantTypeIDErr, application_form_id, isApplicationDatePassed, applicationEndDate, SME_CertificateErr
        } = this.state;
        // console.log("applicationFormList---->",applicationFormList)
        return (
            <>
                {isLoading ? <Loader></Loader> : null}
                <>
                    <main id="main">
                        <div className="website-view">
                            {application_form_id == null ? <Header data={[17]} /> : <Header data={application_form_id} />}
                        </div>
                        <div className="mobile-view">
                            {application_form_id == null ? <MobileHeader data={[17]} /> : <MobileHeader data={application_form_id} />}
                        </div>
                        <section class='header_margin_top'>
                            <div class="container-fluid mt-3">
                                {!applicationBlanked ?
                                    <>
                                        {questionQuerydata.length > 0 ? <>
                                            <div class="d-flex" style={{ marginTop: '5px', justifyContent: 'space-between' }}>
                                                <h4 class="page-title ">
                                                    <span style={{ fontSize: '24px', color: '#f1c841', fontWeight: '600' }}>{(application_no != '' ? 'Application No:' : 'Application Form')} {application_no} <h4 class="page-title" style={{ display: 'inline', color: '#707070' }}> {award_name ? '(' + award_name + ')' : ''}</h4></span>
                                                </h4>
                                                <div className="d-flex">
                                                    <button
                                                        className="btn btn-outline-primary btn-sm mb-3 d-flex align-items-center mr-2"
                                                        style={{ width: "min-content", height: '31px' }}
                                                    >
                                                        <i className="ri-information-line "></i>  <Link
                                                            to="query"
                                                            class="nav-link"
                                                            smooth={true}
                                                            duration={500}
                                                            offset={-100}
                                                        >
                                                            Query
                                                        </Link>
                                                    </button>
                                                    {status_name != '' && <span class="status draft">{status_name} </span>}
                                                </div>
                                            </div>
                                        </> :
                                            <>
                                                <div class="d-flex" style={{ margin: '5px 0 22px 0', justifyContent: 'space-between' }}>
                                                    <h4 class="page-title py-3 pt-4">
                                                        <span style={{ fontSize: '24px', color: '#f1c841', fontWeight: '600' }}>{(application_no != '' ? 'Application No:' : 'Application Form')} {application_no} <h4 class="page-title" style={{ display: 'inline', color: '#707070' }}> {award_name ? '(' + award_name + ')' : ''}</h4></span>
                                                    </h4>
                                                    {status_name != '' && <span class="status draft mt-4">{status_name} </span>}
                                                </div>
                                            </>
                                        }
                                        {/* </div> */}
                                        { }
                                        <div class="card-body p-0">
                                            <div className="company_info mt-3">
                                                <fieldset>
                                                    <div
                                                        className="panel-heading accordion-toggle collapsed "
                                                        data-toggle="collapse"
                                                        data-parent="#accordion"
                                                        data-target="#collapseOne"
                                                        aria-expanded={isCollapse}
                                                        onClick={() =>
                                                            this.setState({
                                                                isCollapse: !isCollapse,
                                                            })
                                                        }
                                                    >
                                                        <legend class="panel-title"><i style={{ verticalAlign: 'middle' }} class="ri-information-line "></i><span style={{ cursor: 'pointer', fontSize: '16px' }} >Instructions</span> <span style={{ marginLeft: '6px' }}>(<a style={{ fontSize: '14px', textDecoration: 'underline', color: '#007bffe8' }}>{isCollapse ? ' Show Less ' : ' Show More '}</a></span>)</legend>
                                                    </div>

                                                    <div class="panel-group" id="accordion">
                                                        <div class="panel panel-default">
                                                            <div
                                                                id="collapseOne"
                                                                className={`panel-collapse p-0 collapse ${isCollapse ? "show" : ""
                                                                    }`}
                                                            >
                                                                <div class="panel-body" style={{ padding: '5px 10px' }}>
                                                                    <div class="form-group" style={{ marginTop: '35px' }}>
                                                                        <div class="row">

                                                                            <table class="table table-bordered">
                                                                                <thead>
                                                                                    <tr>
                                                                                        <th scope="col">Category</th>
                                                                                        <th scope="col">{category_names}</th>
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    <tr>
                                                                                        <td style={{ width: '20%' }}>Theme</td>
                                                                                        <td>
                                                                                            <div dangerouslySetInnerHTML={{
                                                                                                __html: theme
                                                                                            }}
                                                                                            />
                                                                                        </td>
                                                                                    </tr>
                                                                                    <tr>
                                                                                        <td style={{ width: '20%' }}>Eligibility</td>
                                                                                        <td>
                                                                                            <div dangerouslySetInnerHTML={{
                                                                                                __html: eligibility_criteria
                                                                                            }}
                                                                                            />
                                                                                        </td>
                                                                                    </tr>
                                                                                    <tr>
                                                                                        <td style={{ width: '20%' }}>Screening Process</td>
                                                                                        <td>
                                                                                            <div dangerouslySetInnerHTML={{
                                                                                                __html: screening_process
                                                                                            }}
                                                                                            />
                                                                                        </td>
                                                                                    </tr>
                                                                                    <tr>
                                                                                        <td style={{ width: '20%' }}>Important Instructions</td>
                                                                                        <td>
                                                                                            <div dangerouslySetInnerHTML={{
                                                                                                __html: important_instructions
                                                                                            }}
                                                                                            />
                                                                                        </td>
                                                                                    </tr>
                                                                                </tbody>
                                                                            </table>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </fieldset>
                                                {applicationFormList.length > 0 && applicationFormList.map((data, index) => (
                                                    <fieldset key={index}>
                                                        <legend>{data.section_name}</legend>
                                                        <div className="outside_input_field ">
                                                            <div class="row">
                                                                {data.array.length > 0 && data.array.map((item, i) => (
                                                                    <>
                                                                        {
                                                                            (index == 0 && i == 0) &&
                                                                            <>
                                                                                <div className="col-md-6 mt-1">
                                                                                    <label>Applicant Type<span className="mendatory_class">*</span></label>
                                                                                    {console.log("isApplicationDatePassed-->", isApplicationDatePassed)}
                                                                                    <select
                                                                                        className="form-select"
                                                                                        name="TimeSlot"
                                                                                        disabled={statusId > 2 || isApplicationDatePassed}
                                                                                        value={applicantTypeID}
                                                                                        onChange={(e) => {
                                                                                            const { value, options, selectedIndex } = e.target;
                                                                                            this.setState({
                                                                                                applicantTypeIDErr: '',
                                                                                                SME_CertificateErr: '',
                                                                                                sme_certificate_FileName: '',
                                                                                                sme_certificate_FilePath: '',
                                                                                                sme_certificate_FileType: '',
                                                                                                sme_certificate_file_path: '',
                                                                                                applicantTypeID: e.target.value,
                                                                                                applicantTypeName: options[selectedIndex].text,
                                                                                            }, () => { this.getFillList(28, this.state.award_event_profile_id, e.target.value, award_event_id); });
                                                                                        }}
                                                                                    >
                                                                                        <option value={''}>Select</option>
                                                                                        {applicantTypeList.map((data) => (
                                                                                            <option
                                                                                                key={data.applicant_type_id}
                                                                                                value={data.applicant_type_id}
                                                                                            >
                                                                                                {data.applicant_name}
                                                                                            </option>
                                                                                        ))}
                                                                                    </select>
                                                                                    {<span className='text-danger text-start text-left d-block mt-1'>{applicantTypeIDErr}</span>}
                                                                                </div>
                                                                                {applicantTypeName.toLowerCase() == 'msme organization' ?
                                                                                    <div class="col-md-6 mt-1" >
                                                                                        <label>
                                                                                            MSME Certificate<span className="mendatory_class">*</span>
                                                                                            <span className="text-mendate"> (Maximum file size: 5 MB. Allowed formats: pdf)</span>
                                                                                        </label>
                                                                                        {sme_certificate_FileName == '' ?
                                                                                            <div class="form-group mb-0" >
                                                                                                <input type="file" name="files[]" multiple
                                                                                                    disabled={((statusId > 2 && !isIncomplete) || isApplicationDatePassed) || isApplicationDatePassed} class="custom-file-input form-control"
                                                                                                    id="customFile"
                                                                                                    onChange={(e) => this.onSME_CertificateFilePick(e, e.target.files)}
                                                                                                />
                                                                                                <label class="custom-file-label" for="customFile"
                                                                                                >Upload MSME Certificate</label>
                                                                                                {<span className='text-danger text-start text-left d-block mt-1'>{SME_CertificateErr}</span>}
                                                                                            </div> :
                                                                                            <div className='membership_file' >
                                                                                                {download_SME_Certificate_file_path != null && download_SME_Certificate_file_path != '' ?
                                                                                                    <span className='overflow-membership'><a
                                                                                                        href={BASE_URL.split('/api')[0] + download_SME_Certificate_file_path}
                                                                                                        target='blank' style={{ textDecoration: 'none', color: '#414244' }}>{sme_certificate_FileName}</a></span> :
                                                                                                    <span className='overflow-membership' onClick={() => this.handleViewFile(this.state.sme_certificate_FilePath, sme_certificate_FileName)}>{sme_certificate_FileName}</span>
                                                                                                }
                                                                                                {(isIncomplete || statusId <= 2) && !isApplicationDatePassed && < span
                                                                                                    className='membership_file_cross text-danger'
                                                                                                    onClick={(e) => this.remove_SME_certificate(e)}
                                                                                                >X</span>}
                                                                                            </div>
                                                                                        }
                                                                                    </div> :
                                                                                    <div class="col-md-6 mt-1">
                                                                                    </div>
                                                                                }
                                                                                <div class="col-md-6 mt-1">
                                                                                    <label>Country<span className="mendatory_class">*</span></label>
                                                                                    <select id="state" name="Entry Type" class="form-select"
                                                                                        // onKeyDown={(e) => this.handleKeyDown(e)}
                                                                                        value={countryId}
                                                                                        disabled={(statusId > 2 && !isIncomplete) || isApplicationDatePassed}
                                                                                        onChange={e => this.onCountryId(e)}>
                                                                                        <option value=''>Select</option>
                                                                                        {countryList.length > 0 && countryList.map(item => (
                                                                                            <option
                                                                                                key={item.country_id}
                                                                                                value={item.country_id}>
                                                                                                {item.CountryName}
                                                                                            </option>
                                                                                        ))}

                                                                                    </select>{<span className='text-danger text-start text-left d-block mt-1'>{countryIdErr}</span>}
                                                                                </div>
                                                                                <div class="col-md-6 mt-1">
                                                                                    <label>State<span className="mendatory_class">*</span></label>
                                                                                    {countryId != 91 ?
                                                                                        <input value={stateName} type="text"
                                                                                            disabled={(statusId > 2 && !isIncomplete) || isApplicationDatePassed}
                                                                                            onChange={e => this.setState({ stateName: e.target.value, stateErr: '' })}
                                                                                            class="form-control" required
                                                                                            autocomplete="off"
                                                                                            maxLength={30}
                                                                                        /> :
                                                                                        <select id="state" name="Entry Type" class="form-select"
                                                                                            // onKeyDown={(e) => this.handleKeyDown(e)}
                                                                                            value={stateName}
                                                                                            disabled={(statusId > 2 && !isIncomplete) || isApplicationDatePassed}
                                                                                            onChange={e => this.setState({ stateName: e.target.value, stateErr: '' })}>
                                                                                            <option value=''>Select</option>
                                                                                            {this.state.stateList.length > 0 && this.state.stateList.map(item => (
                                                                                                <option
                                                                                                    key={item.state_name}
                                                                                                    value={item.state_name}>
                                                                                                    {item.state_name}
                                                                                                </option>
                                                                                            ))}

                                                                                        </select>
                                                                                    }
                                                                                    {<span className='text-danger text-start text-left d-block mt-1'>{stateErr}</span>}
                                                                                </div>
                                                                                <div class="col-md-6 mt-1">
                                                                                    <label>City<span className="mendatory_class">*</span></label>
                                                                                    <input value={cityName} type="text"
                                                                                        disabled={(statusId > 2 && !isIncomplete) || isApplicationDatePassed}
                                                                                        class="form-control" required
                                                                                        onChange={(e) => this.setState({ cityName: e.target.value, CityNameErr: '' })}
                                                                                        autocomplete="off"
                                                                                        maxLength={30}
                                                                                    />
                                                                                    {/* {isDisplayCityList && this.renderCityList()} */}
                                                                                    {<span className='text-danger text-start text-left d-block mt-1'>{CityNameErr}</span>}
                                                                                </div>
                                                                                <div class="col-md-6 mt-1">
                                                                                    <label> {
                                                                                        countryId == '91' || countryId == '' ? 'Pincode' : 'ZipCode'
                                                                                    }<span className="mendatory_class">*</span></label>
                                                                                    <input value={pinCode} type="text"
                                                                                        class="form-control" required
                                                                                        disabled={(statusId > 2 && !isIncomplete) || isApplicationDatePassed}
                                                                                        onChange={(e) => this.setState({ pinCode: e.target.value.replace(/\D/, ''), pincodeErr: '' })}
                                                                                        autocomplete="off"
                                                                                        maxLength={8}
                                                                                    />
                                                                                    {/* {isDisplayCityList && this.renderCityList()} */}
                                                                                    {<span className='text-danger text-start text-left d-block mt-1'>{pincodeErr}</span>}
                                                                                </div>
                                                                            </>
                                                                        }
                                                                        {(item.controltype_Name == 'Text Box - Numeric') && <div class="col-md-6 mt-1">
                                                                            <div class="form-group mb-0">
                                                                                <label>
                                                                                    {item.fieldname}
                                                                                    {item.is_mandatory && <span className="mendatory_class">*</span>}
                                                                                    <span className="text-mendate">{` (Only Number's)`}</span>
                                                                                </label>
                                                                                <input
                                                                                    type="text"
                                                                                    value={item.applicant_response}
                                                                                    disabled={(statusId > 2 && !isIncomplete) || isApplicationDatePassed}
                                                                                    maxLength={item.max_length}
                                                                                    onChange={(e) => this.handleInput(e.target.value, item.controltype_Name, data.seq_no, i)}
                                                                                    class="form-control"
                                                                                // placeholder={`Enter ${item.fieldname}`}
                                                                                />
                                                                                {<span className='text-danger text-start text-left d-block mt-1'>{item.is_mandatory && item.submitValidation && (item.applicant_response == '' || item.applicant_response == null) ? `Please Enter ${item.fieldname}` : ''}</span>}
                                                                            </div>
                                                                        </div>
                                                                        }
                                                                        {(item.controltype_Name == 'Text Box - Decimal') && <div class="col-md-6 mt-1">
                                                                            <div class="form-group mb-0">
                                                                                <label>
                                                                                    {item.fieldname}
                                                                                    {item.is_mandatory && <span className="mendatory_class">*</span>}
                                                                                    <span className="text-mendate">{` (Only Decimal or Number)`}</span>
                                                                                </label>
                                                                                <input
                                                                                    type="text"
                                                                                    value={item.applicant_response}
                                                                                    disabled={(statusId > 2 && !isIncomplete) || isApplicationDatePassed}
                                                                                    maxLength={item.max_length}
                                                                                    onChange={(e) => this.handleInput(e.target.value, item.controltype_Name, data.seq_no, i)}
                                                                                    class="form-control"
                                                                                // placeholder={`Enter ${item.fieldname}`}
                                                                                />
                                                                                {<span className='text-danger text-start text-left d-block mt-1'>{item.is_mandatory && item.submitValidation && (item.applicant_response == '' || item.applicant_response == null) ? `Please Enter ${item.fieldname}` : ''}</span>}
                                                                            </div>
                                                                        </div>
                                                                        }
                                                                        {(item.controltype_Name == 'Text Box - AlphaNumeric') &&
                                                                            <div class="col-md-6 mt-1">
                                                                                <label>
                                                                                    {item.fieldname}
                                                                                    {item.is_mandatory && <span className="mendatory_class">*</span>}
                                                                                </label>
                                                                                <input
                                                                                    type="text"
                                                                                    disabled={(statusId > 2 && !isIncomplete) || isApplicationDatePassed}
                                                                                    value={item.applicant_response}
                                                                                    maxLength={item.max_length}
                                                                                    onChange={(e) => this.handleInput(e.target.value, item.controltype_Name, data.seq_no, i)}
                                                                                    class="form-control"
                                                                                // placeholder={`Enter ${item.fieldname}`}
                                                                                />
                                                                                {<span className='text-danger text-start text-left d-block mt-1'>{item.is_mandatory && item.submitValidation && (item.applicant_response == '' || item.applicant_response == null) ? `Please Enter ${item.fieldname}` : ''}</span>}
                                                                            </div>
                                                                        }
                                                                        {(item.controltype_Name == 'Text Box - Email') &&
                                                                            <div class="col-md-6 mt-1">
                                                                                <label>
                                                                                    {item.fieldname}
                                                                                    {item.is_mandatory && <span className="mendatory_class">*</span>}
                                                                                </label>
                                                                                <input
                                                                                    type="text"
                                                                                    disabled={(statusId > 2 && !isIncomplete) || isApplicationDatePassed}
                                                                                    value={item.applicant_response}
                                                                                    maxLength={item.max_length}
                                                                                    onChange={(e) => this.handleInput(e.target.value, item.controltype_Name, data.seq_no, i)}
                                                                                    class="form-control"
                                                                                // placeholder={`Enter ${item.fieldname}`}
                                                                                />
                                                                                {<span className='text-danger text-start text-left d-block mt-1'>{item.is_mandatory && item.submitValidation && (item.applicant_response == '' || item.applicant_response == null) ? `Please Enter ${item.fieldname}` : ''}</span>}
                                                                                {<span className='text-danger text-start text-left d-block mt-1'>{item.applicant_response != '' && item.applicant_response != null && item.applicationErr != undefined && item.applicationErr != '' ? ` ${item.applicationErr}` : ''}</span>}
                                                                            </div>
                                                                        }
                                                                        {(item.controltype_Name == 'Text Box - Website') &&
                                                                            <div class="col-md-6 mt-1">
                                                                                <label>
                                                                                    {item.fieldname}
                                                                                    {item.is_mandatory && <span className="mendatory_class">*</span>}
                                                                                </label>
                                                                                <input
                                                                                    type="text"
                                                                                    disabled={(statusId > 2 && !isIncomplete) || isApplicationDatePassed}
                                                                                    value={item.applicant_response}
                                                                                    maxLength={item.max_length}
                                                                                    onChange={(e) => this.handleInput(e.target.value, item.controltype_Name, data.seq_no, i)}
                                                                                    class="form-control"
                                                                                // placeholder={`Enter ${item.fieldname}`}
                                                                                />
                                                                                {<span className='text-danger text-start text-left d-block mt-1'>{item.is_mandatory && item.submitValidation && (item.applicant_response == '' || item.applicant_response == null) ? `Please Enter ${item.fieldname}` : ''}</span>}
                                                                                {<span className='text-danger text-start text-left d-block mt-1'>{item.applicant_response != '' && item.applicant_response != null && item.applicationErr != undefined && item.applicationErr != '' ? ` ${item.applicationErr}` : ''}</span>}
                                                                            </div>
                                                                        }
                                                                        {(item.controltype_Name == 'Text Box - Phone Number') &&
                                                                            <div class="col-md-6 mt-1">
                                                                                <label>
                                                                                    {item.fieldname}
                                                                                    {item.is_mandatory && <span className="mendatory_class">*</span>}
                                                                                </label>
                                                                                <input
                                                                                    type="text"
                                                                                    disabled={(statusId > 2 && !isIncomplete) || isApplicationDatePassed}
                                                                                    value={item.applicant_response}
                                                                                    maxLength={item.max_length}
                                                                                    onChange={(e) => this.handleInput(e.target.value, item.controltype_Name, data.seq_no, i)}
                                                                                    class="form-control"
                                                                                // placeholder={`Enter ${item.fieldname}`}
                                                                                />
                                                                                {<span className='text-danger text-start text-left d-block mt-1'>{item.is_mandatory && item.submitValidation && (item.applicant_response == '' || item.applicant_response == null) ? `Please Enter ${item.fieldname}` : ''}</span>}
                                                                                {<span className='text-danger text-start text-left d-block mt-1'>{item.applicant_response != '' && item.applicant_response != null && item.applicationErr != undefined && item.applicationErr != '' ? ` ${item.applicationErr}` : ''}</span>}
                                                                            </div>
                                                                        }
                                                                        {(item.controltype_Name == 'Multiline Text Box') && <div class="col-md-6 mt-1">
                                                                            <div class="form-group mb-0">
                                                                                <label>
                                                                                    {item.fieldname}
                                                                                    {item.is_mandatory && <span className="mendatory_class">*</span>}
                                                                                </label>
                                                                                <textarea
                                                                                    cols={4}
                                                                                    rows={6}
                                                                                    type="text"
                                                                                    disabled={(statusId > 2 && !isIncomplete) || isApplicationDatePassed}
                                                                                    value={item.applicant_response}
                                                                                    maxLength={item.max_length}
                                                                                    onChange={(e) => this.handleInput(e.target.value, item.controltype_Name, data.seq_no, i)}
                                                                                    class="form-control"
                                                                                // placeholder={`Enter ${item.fieldname}`}
                                                                                />
                                                                                {<span className='text-danger text-start text-left d-block mt-1'>{item.is_mandatory && item.submitValidation && (item.applicant_response == '' || item.applicant_response == null) ? `Please Enter ${item.fieldname}` : ''}</span>}
                                                                            </div>
                                                                        </div>
                                                                        }
                                                                        {(item.controltype_Name == 'Date Picker') && <div class="col-md-6 mt-1">
                                                                            <div class="form-group mb-0">
                                                                                <label>
                                                                                    {item.fieldname}
                                                                                    {item.is_mandatory && <span className="mendatory_class">*</span>}
                                                                                </label>
                                                                                <DatePicker className="form-control"
                                                                                    dateFormat="dd-MM-yyyy"
                                                                                    disabled={(statusId > 2 && !isIncomplete) || isApplicationDatePassed}
                                                                                    selected={item.applicant_response != null ? new Date(item.applicant_response) : item.applicant_response}
                                                                                    onChange={(date) => this.handleInput(date, item.controltype_Name, data.seq_no, i)}
                                                                                    peekNextMonth
                                                                                    showMonthDropdown
                                                                                    showYearDropdown
                                                                                    dropdownMode="select"
                                                                                    placeholderText="DD/MM/YYYY"
                                                                                />
                                                                                {<span className='text-danger text-start text-left d-block mt-1'>{item.is_mandatory && item.submitValidation && (item.applicant_response == '' || item.applicant_response == null) ? `Please Select ${item.fieldname}` : ''}</span>}
                                                                            </div>
                                                                        </div>
                                                                        }
                                                                        {(item.controltype_Name == 'Dropdown - Single-Select') &&
                                                                            <div class="col-md-6 mt-1">
                                                                                <div class="form-group mb-0">
                                                                                    <label>
                                                                                        {item.fieldname}
                                                                                        {item.is_mandatory && <span className="mendatory_class">*</span>}
                                                                                    </label>
                                                                                    <select
                                                                                        class="form-select"
                                                                                        disabled={(statusId > 2 && !isIncomplete) || isApplicationDatePassed}
                                                                                        value={item.applicant_response}
                                                                                        onChange={(e) => this.handleInput(e.target.value, item.controltype_Name, data.seq_no, i)}
                                                                                    >
                                                                                        <option>Select</option>
                                                                                        {item.optionData != undefined && item.optionData.length > 0 &&
                                                                                            item.optionData.map((option) => (
                                                                                                <option
                                                                                                    key={option.options}
                                                                                                    value={option.options}
                                                                                                >
                                                                                                    {option.options}
                                                                                                </option>
                                                                                            ))}
                                                                                    </select>
                                                                                    {<span className='text-danger text-start text-left d-block mt-1'>{item.is_mandatory && item.submitValidation && (item.applicant_response == '' || item.applicant_response == null) ? `Please Select ${item.fieldname}` : ''}</span>}
                                                                                </div>
                                                                            </div>
                                                                        }
                                                                        {(item.controltype_Name == 'Dropdown - Multi-Select') && <div class="col-md-6 mt-1">
                                                                            <div class="form-group mb-0">
                                                                                <label>
                                                                                    {item.fieldname}
                                                                                    {item.is_mandatory && <span className="mendatory_class">*</span>}
                                                                                    <span className="text-mendate">{` (Multi Select Option's)`}</span>
                                                                                </label>
                                                                                <Select
                                                                                    isMulti
                                                                                    isDisabled={(statusId > 2 && !isIncomplete) || isApplicationDatePassed}
                                                                                    onChange={(e) => this.handleInput(e, item.controltype_Name, data.seq_no, i)}
                                                                                    styles={customStyles}
                                                                                    value={item.Multi_Select_value}
                                                                                    options={item.optionData}
                                                                                />
                                                                                {<span className='text-danger text-start text-left d-block mt-1'>{item.is_mandatory && item.submitValidation && (item.applicant_response == '' || item.applicant_response == null) ? `Please Select ${item.fieldname}` : ''}</span>}
                                                                            </div>
                                                                        </div>
                                                                        }
                                                                        {(item.controltype_Name == 'Checkbox - Single-Select') &&
                                                                            <div class="col-md-12 mt-1">
                                                                                <div class="form-group mb-0">
                                                                                    <>
                                                                                        <label>
                                                                                            {item.fieldname}
                                                                                            {item.is_mandatory && <span className="mendatory_class">*</span>}
                                                                                            <span className="text-mendate">{` (Single Select Checkbox)`}</span>
                                                                                        </label>
                                                                                        <div className="bg only_checkbox d-flex flex-column" style={{ flexWrap: 'wrap' }}>
                                                                                            {item.optionData.length > 0 && item.optionData.map((option, objIndex) => (
                                                                                                // <div class="col-md-3 mb-3" key={objIndex}>
                                                                                                <div className="" >

                                                                                                    <label
                                                                                                        className="lebel-dis d-flex"
                                                                                                        htmlFor={`ServiceCheck-${objIndex}-${item.fieldname}`}
                                                                                                        style={{ color: "#979797", marginLeft: '12px' }}
                                                                                                    >
                                                                                                        <input type="checkbox" className="mr-2"
                                                                                                            disabled={(statusId > 2 && !isIncomplete) || isApplicationDatePassed}
                                                                                                            checked={option.isChecked}
                                                                                                            onClick={(e) => this.handleInput(e.target.checked, item.controltype_Name, data.seq_no, i, option.options)}
                                                                                                            id={`ServiceCheck-${objIndex}-${item.fieldname}`} />
                                                                                                        {option.options}
                                                                                                    </label>
                                                                                                    <span></span>
                                                                                                </div>
                                                                                                // </div>
                                                                                            ))}
                                                                                        </div>
                                                                                        {<span className='text-danger text-start text-left d-block mt-1'>{item.is_mandatory && item.submitValidation && (item.applicant_response == '' || item.applicant_response == null) ? `Please Select ${item.fieldname}` : ''}</span>}
                                                                                    </>
                                                                                </div>
                                                                            </div>
                                                                        }
                                                                        {(item.controltype_Name == 'Checkbox - Multi-Select') &&
                                                                            <div class="col-md-12 mt-1">
                                                                                <div class="form-group mb-0">
                                                                                    <>
                                                                                        <label>
                                                                                            {item.fieldname}
                                                                                            {item.is_mandatory && <span className="mendatory_class">*</span>}
                                                                                            <span className="text-mendate">{` (Multi Select Checkbox)`}</span>
                                                                                        </label>
                                                                                        <div className="bg only_checkbox d-flex flex-column" style={{ flexWrap: 'wrap' }}>
                                                                                            {item.optionData != undefined && item.optionData.length > 0 && item.optionData.map((option, index) => (
                                                                                                // <div class="col-md-3 mb-3">
                                                                                                <div className="" key={index}>

                                                                                                    <label
                                                                                                        className="lebel-dis d-flex h-auto lh-base"
                                                                                                        htmlFor={`ServiceMultiCheck-${index}-${item.fieldname}`}
                                                                                                        style={{ color: "#979797", marginLeft: '12px', lineHeight: '12px' }}
                                                                                                    >
                                                                                                        <input type="checkbox" className="mr-2"
                                                                                                            disabled={(statusId > 2 && !isIncomplete) || isApplicationDatePassed}
                                                                                                            checked={option.isChecked}
                                                                                                            onChange={(e) => this.handleInput(e.target.checked, item.controltype_Name, data.seq_no, i, option.options)}
                                                                                                            id={`ServiceMultiCheck-${index}-${item.fieldname}`} />
                                                                                                        {option.options}
                                                                                                    </label>
                                                                                                    <span></span>
                                                                                                    {/* </div> */}
                                                                                                </div>
                                                                                            ))}
                                                                                        </div>
                                                                                        {<span className='text-danger text-start text-left d-block mt-1'>{item.is_mandatory && item.submitValidation && (item.applicant_response == '' || item.applicant_response == null) ? `Please Select ${item.fieldname}` : ''}</span>}
                                                                                    </>
                                                                                </div>
                                                                            </div>
                                                                        }
                                                                        {(item.controltype_Name == 'File Upload') &&
                                                                            <div class="col-md-6 mt-1">
                                                                                <div class="form-group mb-0">
                                                                                    <label>
                                                                                        {item.fieldname}
                                                                                        {item.is_mandatory && <span className="mendatory_class">*</span>}
                                                                                        <span className="text-mendate">{` (Maximum file size: ${item.max_size} MB. Allowed formats: ${item.file_format != null && item.file_format.replace(/,/g, ", ")})`}</span>
                                                                                    </label>
                                                                                    {item.FileName == null ?
                                                                                        <>
                                                                                            <div class="form-group mb-0"  >
                                                                                                <input type="file" name="files[]" multiple class="custom-file-input form-control"
                                                                                                    disabled={(statusId > 2 && !isIncomplete) || isApplicationDatePassed}
                                                                                                    id="customFile"
                                                                                                    onChange={(e) => this.onFilePick(e, e.target.files, item.controltype_Name, data.seq_no, i, item.file_format, item.max_size)}
                                                                                                />
                                                                                                <label class="custom-file-label" for="customFile"
                                                                                                >File Upload</label>
                                                                                            </div>
                                                                                            {<span className='text-danger text-start text-left d-block mt-1'>{item.is_mandatory && item.submitValidation && item.FileName == null ? `Please Select ${item.fieldname}` : ''}</span>}
                                                                                        </>
                                                                                        :
                                                                                        <div className='membership_file' >
                                                                                            {item.file_path != null ?
                                                                                                <span className='overflow-membership' > <a href={BASE_URL.split('/api')[0] + '/' + (item.file_path.split('./')[1])} title={item.FileName}
                                                                                                    target='blank'> {item.FileName}</a></span> :
                                                                                                <span className='overflow-membership' > <a title={item.FileName}
                                                                                                    target='blank'
                                                                                                    onClick={() => this.handleViewFile(item.FilePath, item.FileName)}
                                                                                                > {item.FileName}</a></span>
                                                                                            }
                                                                                            {(isIncomplete || statusId <= 2) && !isApplicationDatePassed &&
                                                                                                <span
                                                                                                    className='membership_file_cross text-danger'
                                                                                                    onClick={() => this.removeFile(item.controltype_Name, data.seq_no, i,)}
                                                                                                >X</span>
                                                                                            }
                                                                                        </div>
                                                                                    }
                                                                                </div>
                                                                            </div>
                                                                        }
                                                                    </>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    </fieldset>
                                                ))}

                                                <fieldset>
                                                    <legend> Declaration Message</legend>
                                                    <div className="row w-100">
                                                        <div className="content col-12">
                                                            {/* <pre style={{ margin: '0 auto', textAlign: 'center', justifyContent:'center' }}
                                                                dangerouslySetInnerHTML={{
                                                                    __html: DeclarationData
                                                                }}
                                                            /> */}
                                                            <div
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'column',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                    padding: '10px',
                                                                    textAlign: 'left',
                                                                    fontFamily: "'Book Antiqua', serif",
                                                                    fontSize: '16px',
                                                                    lineHeight: '1.5',
                                                                }}
                                                                dangerouslySetInnerHTML={{ __html: (isIncomplete || statusId <= 2) ? DOMPurify.sanitize(DeclarationMessage) : '' }}
                                                            />
                                                        </div>
                                                    </div>
                                                </fieldset>
                                                <fieldset>
                                                    <legend> Declaration</legend>
                                                    <div className="row">
                                                        <div className='col-12 d-flex' style={{ justifyContent: 'right' }}>

                                                            {(DeclarationFileName == '' || DeclarationFileName == null) &&
                                                                <button type="button" class="btn btn-outline-primary mr-1" onClick={() => this.generatePdf()}><a title="Download Declaration Template"><i class="ri-file-download-line"></i>{" "} Download</a></button>
                                                            }
                                                            {(DeclarationFileName == '' || DeclarationFileName == null) ?
                                                                <button type="button" class="btn btn-outline-secondary mr-1" onClick={() => this.toggleUploadModal()}>
                                                                    <a title="Upload Declaration file">  Upload</a></button> :
                                                                <>
                                                                    {(isIncomplete || statusId <= 2) && !isApplicationDatePassed && <button type="button" class="btn btn-outline-danger mr-1" onClick={(e) => this.removeDeclarationFile(e)}><a title="Discard uploaded file">Remove</a></button>}
                                                                </>
                                                            }
                                                            {download_Declaration_file_path != null && download_Declaration_file_path != '' ?
                                                                <a type="button" class="btn btn-outline-success mr-1 view-btn" href={BASE_URL.split('/api')[0] + download_Declaration_file_path} title={DeclarationFileName}
                                                                    target='blank' ><i class="ri-external-link-line mt-1"></i>{" "}View Declaration</a>
                                                                :
                                                                <>
                                                                    {this.state.DeclarationFilePath != '' &&
                                                                        <a class="btn btn-outline-success mr-1" onClick={() => this.handleViewFile(this.state.DeclarationFilePath, DeclarationFileName)} title={DeclarationFileName}
                                                                            target='blank' ><i class="ri-external-link-line"></i>{" "}View Declaration</a>
                                                                    }
                                                                </>
                                                            }

                                                        </div>
                                                    </div>
                                                    <div className="row w-100">
                                                        <div className="content col-12">
                                                            {/* <pre style={{ margin: '0 auto', textAlign: 'center', justifyContent:'center' }}
                                                                dangerouslySetInnerHTML={{
                                                                    __html: DeclarationData
                                                                }}
                                                            /> */}
                                                            <div
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'column',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                    padding: '10px',
                                                                    textAlign: 'center',
                                                                    fontFamily: "'Book Antiqua', serif",
                                                                    fontSize: '16px',
                                                                    lineHeight: '1.5',
                                                                }}
                                                                dangerouslySetInnerHTML={{ __html: (isIncomplete || statusId <= 2) ? DOMPurify.sanitize(DeclarationData) : '' }}
                                                            />
                                                        </div>
                                                    </div>
                                                </fieldset>

                                                {/* <fieldset>
                                                    <legend className="m-0"> Payment Type</legend>
                                                    <div className="col-3 mb-2">
                                                        <div className="d-flex mt-2">
                                                            <label style={{ width: 0, width: 'fix-content', marginRight: '15px' }}>
                                                                <input
                                                                    className="mr-1"
                                                                    style={{ verticalAlign: 'middle' }}
                                                                    type="radio"
                                                                    value="option1"
                                                                    checked={this.state.paymentType === 'Online'}
                                                                    onChange={(e) => this.setState({ paymentType: 'Online' })}
                                                                />
                                                                Online
                                                            </label>
                                                            <label >
                                                                <input
                                                                    style={{ verticalAlign: 'middle' }}
                                                                    type="radio"
                                                                    className="mr-1"
                                                                    value="option2"
                                                                    checked={this.state.paymentType === 'Offline'}
                                                                    onChange={(e) => this.setState({ paymentType: 'Offline' })}
                                                                />
                                                                Offline
                                                            </label>
                                                        </div>
                                                    </div>
                                                </fieldset> */}
                                            </div>
                                        </div>
                                        <Modal show={isUploadModal}
                                            size="md"
                                            onHide={() => this.toggleUploadModal()}
                                        >
                                            <Modal.Body>
                                                <div class="container-fluid">
                                                    <div class="page-header">
                                                        <h4 class="page-title" style={{ width: '90%' }}>Upload Declaration
                                                            <span className="text-mendate"> (Maximum file size: 5 MB. Allowed formats: pdf)</span>
                                                        </h4>
                                                        <div className="Service_display">
                                                            <h1
                                                                className="Services_Active_or_Not mr-0 mb-3"
                                                                style={{
                                                                    fontSize: "25px",
                                                                    fontWeight: "800",
                                                                    cursor: "pointer",
                                                                }}
                                                                onClick={() => this.toggleUploadModal()}
                                                            >
                                                                X
                                                            </h1>
                                                        </div>
                                                    </div>
                                                    <div class="form-group mt-1" >
                                                        <input type="file" name="files[]" multiple class="custom-file-input form-control"
                                                            id="customFile"
                                                            onChange={(e) => this.onDeclarationFormFilePick(e, e.target.files)}
                                                        />
                                                        <label class="custom-file-label" for="customFile"
                                                        >Upload Declaration Form</label>
                                                        {DeclarationFileName != '' ? <>
                                                            <div className='membership_file mt-2'>
                                                                <span className='overflow-membership w-auto'>{DeclarationFileName}</span>
                                                            </div>
                                                        </> : <></>}
                                                    </div>
                                                </div>
                                            </Modal.Body>
                                            <Modal.Footer>
                                                <button className="btn btn-primary btn-sm" onClick={() => this.toggleUploadModal()}>Close</button>
                                            </Modal.Footer>
                                        </Modal>

                                        <Modal show={isInstructionsOpen}
                                            size="xl"
                                            onHide={() => this.toggleInstructionDetails()}
                                        >
                                            <Modal.Body>
                                                <div class="container-fluid">
                                                    <div class="page-header">
                                                        <h4 class="page-title">Instructions</h4>
                                                        <div className="Service_display pt-2">
                                                            <h1
                                                                className="Services_Active_or_Not"
                                                                style={{
                                                                    fontSize: "25px",
                                                                    fontWeight: "800",
                                                                    cursor: "pointer",
                                                                }}
                                                                onClick={() => this.toggleInstructionDetails()}
                                                            >
                                                                X
                                                            </h1>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-md-12">
                                                            <div className="awards-container">
                                                                <div className="awards-row">
                                                                    <div className="label">Category</div>
                                                                    <div className="content">
                                                                        {(() => {
                                                                            const categoryName = categoryFillList.find(
                                                                                (item) => item.category_id === category_id
                                                                            );
                                                                            return categoryName ? categoryName.category_name : "";
                                                                        })()}
                                                                    </div>

                                                                </div>

                                                                <div className="awards-row">
                                                                    <div className="label">Theme</div>
                                                                    <div className="content">
                                                                        <div dangerouslySetInnerHTML={{
                                                                            __html: theme
                                                                        }}
                                                                        />
                                                                    </div>
                                                                </div>

                                                                <div className="awards-row">
                                                                    <div className="label">Eligibility</div>
                                                                    <div className="content">
                                                                        <div dangerouslySetInnerHTML={{
                                                                            __html: eligibility_criteria
                                                                        }}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="awards-row">
                                                                    <div className="label">Screening Process</div>
                                                                    <div className="content">
                                                                        <div dangerouslySetInnerHTML={{
                                                                            __html: screening_process
                                                                        }}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="awards-row">
                                                                    <div className="label">Important Instructions</div>
                                                                    <div className="content">
                                                                        <div dangerouslySetInnerHTML={{
                                                                            __html: important_instructions
                                                                        }}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </Modal.Body>
                                            <Modal.Footer>
                                                <button className="btn btn-primary btn-sm" onClick={() => this.toggleInstructionDetails()}>Close</button>
                                            </Modal.Footer>
                                        </Modal>

                                        <div class="row">
                                            {!isApplicationDatePassed ?
                                                <div class="col-md-12 text-left">
                                                    {
                                                        statusId < 3 ?
                                                            <>
                                                                <button
                                                                    onClick={() => this.handleSaveAsDraft()}
                                                                    className="btn btn-outline-warning full-width-btn"
                                                                    style={{ cursor: 'pointer' }}
                                                                >
                                                                    Save as Draft
                                                                </button>
                                                                {isAplicationIsPaid ?
                                                                    <>
                                                                        {sessionStorage.getItem('isPg') == 1 || sessionStorage.getItem('isPg') == true ?
                                                                            <>
                                                                                <button
                                                                                    onClick={() => this.isModal('online')}
                                                                                    className="btn btn-outline-primary mr-5 full-width-btn"
                                                                                    // disabled={true}
                                                                                    style={{ width: 'auto' }}
                                                                                >
                                                                                    Submit with payment
                                                                                </button>
                                                                            </> : <>
                                                                                <button
                                                                                    onClick={() => this.isModal('pending')}
                                                                                    className="btn btn-outline-success mar-left-right full-width-btn"
                                                                                    style={{ cursor: 'pointer', width: 'auto' }}
                                                                                >
                                                                                    Submit and pay later
                                                                                </button>
                                                                            </>}
                                                                    </> :
                                                                    <button
                                                                        onClick={() => this.isModal('N.A')}
                                                                        class="btn btn-outline-success mx-2 full-width-btn"
                                                                        style={{ cursor: 'pointer', width: 'auto' }}
                                                                    >
                                                                        Submit
                                                                    </button>
                                                                }
                                                            </>
                                                            :
                                                            <>
                                                                {!isIncomplete ?
                                                                    <>
                                                                        <button
                                                                            className="btn btn-outline-primary mr_5 full-width-btn"
                                                                            disabled={true}

                                                                        >
                                                                            Submitted
                                                                        </button>
                                                                        {(paymentType == 'pending' && isAplicationIsPaid && (sessionStorage.getItem('isPg') == 1 || sessionStorage.getItem('isPg') == true)) ? (
                                                                            <button
                                                                                onClick={() => this.isModal('online')}
                                                                                className="btn btn-outline-success full-width-btn"
                                                                            // disabled={true}
                                                                            >
                                                                                Pay Now
                                                                            </button>
                                                                        ) : <></>}
                                                                    </>
                                                                    :
                                                                    <button
                                                                        onClick={() => this.isModal(paymentType)}
                                                                        className="btn btn-success mx-2 full-width-btn"
                                                                        style={{ cursor: 'pointer', width: 'auto' }}
                                                                    >
                                                                        Submit
                                                                    </button>
                                                                }
                                                            </>
                                                    }
                                                </div> :
                                                <div class="col-md-12 text-left">
                                                    <span className="text-danger d-block mt-1">
                                                        The deadline to fill out the form has passed on {applicationEndDate}
                                                    </span>
                                                </div>
                                            }
                                        </div >
                                        {questionQuerydata.length > 0 && <div className="card-body mt-4">
                                            <div className="company_info">
                                                <Element name="query" className="element">
                                                    <fieldset>
                                                        <legend>Query</legend>
                                                        <div className="outside_input_field">
                                                            <div className="query-container">
                                                                {questionQuerydata.length > 0 ? questionQuerydata.map((data) => (
                                                                    <>
                                                                        <div className="query">
                                                                            <div className="user-icon ps">{data.question_author
                                                                                .split(" ").map((word) => word[0])
                                                                                .join("").toUpperCase()}</div>
                                                                            <div className="query-content">
                                                                                <div className="query-header row">
                                                                                    <div className="col-10">
                                                                                        <span className="user-name">{data.question_author}</span>
                                                                                        <span className="timestamp px-2">
                                                                                            {data.question_time} | {moment(data.question_date).format('DD-MMM-YYYY')}
                                                                                        </span>
                                                                                    </div>
                                                                                    <div className="col-1 text-right">
                                                                                        <i class={isReplyMode ? "ri-close-line querycancel" : 'ri-reply-line'} onClick={() => this.onReplyToggle(data.question_id)}></i>
                                                                                    </div>
                                                                                </div>
                                                                                <p className="query-text" >
                                                                                    {data.title}
                                                                                </p>
                                                                                {/* <p className="query-text">
                                                                                    <div dangerouslySetInnerHTML={{
                                                                                        __html: data.question_content
                                                                                    }}
                                                                                    />
                                                                                </p> */}
                                                                            </div>
                                                                            {data?.answerQueryData?.length > 0 && data?.answerQueryData?.map((answer) => (
                                                                                <div className="query" style={{ marginLeft: '50px' }}>
                                                                                    <div className="user-icon ps">{answer.answer_author
                                                                                        .split(" ").map((word) => word[0])
                                                                                        .join("").toUpperCase()}</div>
                                                                                    <div className="query-content">
                                                                                        <div className="query-header row">
                                                                                            <div className="col-10">
                                                                                                <span className="user-name">{answer.answer_author}</span>
                                                                                                <span className="timestamp px-2">
                                                                                                    {answer.answer_time} | {moment(answer.answer_date).format('DD-MMM-YYYY')}
                                                                                                </span>
                                                                                            </div>
                                                                                            {/* <div className="col-1">
                                                                                                <button className="send-button" onClick={() => this.onReplyToggle()}><i class="ri-reply-line" style={{ fontSize: '24px' }}></i></button>
                                                                                            </div> */}
                                                                                        </div>
                                                                                        <p className="query-text">
                                                                                            <div dangerouslySetInnerHTML={{
                                                                                                __html: answer.answer_content
                                                                                            }}
                                                                                            />
                                                                                        </p>
                                                                                    </div>
                                                                                </div>
                                                                            ))}
                                                                        </div>
                                                                        {isReplyMode && (question_id === data.question_id) ? (<>
                                                                            <div className="reply-box mb-5">
                                                                                <div className="user-icon vs replay-cir"> {sessionStorage.getItem("user_name") &&
                                                                                    sessionStorage
                                                                                        .getItem("user_name")
                                                                                        .split(" ")
                                                                                        .map((word) => word[0])
                                                                                        .join("")
                                                                                        .toUpperCase()}</div>
                                                                                <textarea rows={2} value={queryPostContent} maxLength={500} class="reply-input rounded-0" onChange={(e) => this.setState({ queryPostContent: e.target.value })}></textarea>
                                                                                <button className="send-button" onClick={() => this.replyQuery(data.question_id)}><i class="ri-send-plane-2-line"></i></button>
                                                                            </div>
                                                                        </>
                                                                        ) : <></>}
                                                                    </>
                                                                )) : (
                                                                    <>
                                                                    </>
                                                                )}

                                                                {/*
                                                            <div className="mt-4">
                                                                <div class="containerr">
                                                                    <div class="title">Call Back</div>
                                                                    <div className="row m-4 mb-2 mt-1 bg-light p-4 border rounded-1">
                                                                        <div className="col-md-3 form-group mb-0">
                                                                            <input type="date" class="form-control border-input" placeholder="Enter Contact Person" value="abc"></input>
                                                                        </div>
                                                                        <div className="col-md-3 form-group mb-0">
                                                                            <input type="time" class="form-control border-input" placeholder="Enter Contact Person" value="abc"></input>
                                                                        </div>
                                                                        <div className="col-md-3 form-group mb-0">
                                                                            <button type="btn" class="btn btn-outline-warning rounded-1">Submit</button>
                                                                        </div>
                                                                    </div>
                                                                </div> 
                                                                 <div class="containerr" style={{ marginTop: '40px' }}>
                                                                    <div class="title">Co-ordinator Details</div>
                                                                    <table class="details-table">
                                                                        <thead>
                                                                            <tr>
                                                                                <th>Name</th>
                                                                                <th>Email</th>
                                                                                <th>Mobile</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {queryCoordinatorData.length > 0 ? queryCoordinatorData.map((data) => (
                                                                                <tr>
                                                                                    <td>{data.name}</td>
                                                                                    <td>{data.email_address}</td>
                                                                                    <td>{data.contact_no}</td>
                                                                                </tr>
                                                                            )) : (
                                                                                <tr>
                                                                                    <td colSpan={3}>No record found</td>
                                                                                </tr>

                                                                            )}
                                                                        </tbody>
                                                                    </table>
                                                                </div>

                                                            </div> */}

                                                            </div>
                                                        </div>
                                                    </fieldset>
                                                </Element>
                                            </div>
                                        </div>}
                                    </> :
                                    <div class="page-header">
                                        <h4 class="page-title text-center">
                                            Record not found
                                        </h4>
                                    </div>
                                }
                            </div>
                        </section>
                    </main>
                    <Modal show={show} size="xl">
                        <Modal.Header>
                            <Modal.Title><span style={{ marginLeft: '15px' }}>Price Details</span></Modal.Title>
                            <span
                                onClick={() => this.setState({ show: !show })}
                                style={{ cursor: "pointer", fontWeight: "800", marginRight: '15px' }}
                            >
                                X
                            </span>
                        </Modal.Header>

                        <Modal.Body>
                            <table
                                class="table table-bordered"
                                id="dashboard-table"
                            >
                                <thead>
                                    <tr>
                                        <th >{applicantPricingList.length > 0 && applicantPricingList[0]['applicant_type']} Applicant Fee</th>
                                        <th >Rate{applicantPricingList.length > 0 && (applicantPricingList[0]['currency_id'] == 1) ? '(INR)' : '(USD)'} </th>
                                    </tr>
                                </thead>
                                <tbody id="myTable">
                                    <tr>
                                        <td>Taxable Amount</td>
                                        <td>{applicantPricingList.length > 0 && applicantPricingList[0]['taxable_amt'].toLocaleString()}</td>
                                    </tr>
                                    <tr>
                                        <td>CGST</td>
                                        <td>{applicantPricingList.length > 0 && applicantPricingList[0]['cgst'].toLocaleString()}</td>
                                    </tr>
                                    <tr>
                                        <td>SGST</td>
                                        <td>{applicantPricingList.length > 0 && applicantPricingList[0]['sgst'].toLocaleString()}</td>
                                    </tr>
                                    <tr>
                                        <td>IGST</td>
                                        <td>{applicantPricingList.length > 0 && applicantPricingList[0]['igst'].toLocaleString()}</td>
                                    </tr>
                                    <tr>
                                        <td>Round off</td>
                                        <td>{applicantPricingList.length > 0 && applicantPricingList[0]['round_off'].toLocaleString()}</td>
                                    </tr>
                                    <tr>
                                        <td>Total Amount</td>
                                        <td>{applicantPricingList.length > 0 && applicantPricingList[0]['grand_total'].toLocaleString()}</td>
                                    </tr>
                                </tbody>
                            </table>
                            <div style={{ float: 'right' }}>
                                <button
                                    // onClick={(e) => this.navPayment(e)}
                                    onClick={() => this.setState({ isOpen2: true })}
                                    class="btn btn-outline-success mx-2"
                                    style={{ cursor: 'pointer', width: 'auto' }}
                                >
                                    Submit and Pay now
                                </button>
                                <button
                                    onClick={() => this.setState({ show: !show })}
                                    class="btn btn-outline-secondary"
                                >
                                    Cancel
                                </button>
                            </div>
                        </Modal.Body>
                    </Modal>
                    <Modal show={this.state.isOpen} size="xl">
                        <Modal.Header>
                            <Modal.Title style={{ width: '100%', textAlign: 'center' }}>
                                {/* <div > */}
                                <h4><strong>Application Form Submitted SuccessFully</strong></h4>
                                {/* </div> */}
                            </Modal.Title>
                            <span
                                onClick={() => this.setState({ isOpen: false })}
                                style={{ cursor: "pointer", fontWeight: "800", marginRight: '15px' }}
                            >
                                X
                            </span>
                        </Modal.Header>

                        <Modal.Body>
                            <div>
                                <p className="mb-1 mt-1 text-center com-font">
                                    Thank you for submitting your Application
                                </p>
                                {<p className="mb-0 mt-2 text-center com-font">
                                    Your payment has been successfully processed. transactionID: <strong>{this.state.orderNo}</strong> and total: <strong>{parseInt(this.state.countryId) == 91 ? '₹' : '$'}{this.state.paidAmount}</strong>
                                </p>}
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <div class="row">
                                <div class="col-md-12 text-left">
                                    <button
                                        onClick={() => this.setState({ isOpen: false }, () => {
                                            this.props.navigate('/applicantDashboard', {
                                                state: { application_no: application_no }
                                            })
                                        })}
                                        class="btn btn-warning"
                                        style={{ cursor: 'pointer' }}
                                    >
                                        OK
                                    </button>
                                </div>
                            </div>

                        </Modal.Footer>
                    </Modal>

                    <Modal show={this.state.isOpen2} size="xl" style={{ backdropFilter: 'blur(5px)' }}>
                        <Modal.Header>
                            <Modal.Title style={{ width: '100%', textAlign: 'center' }} >
                                {/* <div > */}
                                <h6>Do you really want to submit Application Form ? </h6>
                                {/* </div> */}
                            </Modal.Title>
                            <span
                                onClick={() => this.setState({ isOpen2: false })}
                                style={{ cursor: "pointer", fontWeight: "800", marginRight: '15px' }}
                            >
                                X
                            </span>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="mt-3 fs-5 fw-bold">
                                <span className="text-danger text-start text-left d-block">
                                    After submission you will not be able to change the fields
                                </span>
                            </div>
                            {sessionStorage.getItem('isPg') == 1 || sessionStorage.getItem('isPg') == true ? <>
                                <div className="mt-3 fs-5 fw-bold">
                                    <span className="text-danger text-start text-left d-block">
                                        Please note that bank charges alongwith GST will be applicable as per selected mode of payment in the next step
                                    </span>
                                </div>
                                <table className="table table-bordered table-striped mg-b-0">
                                    <thead>
                                        <tr>
                                            <th>Payment Mode</th>
                                            <th>Bank Charges</th>
                                        </tr>
                                    </thead>
                                    <tbody id="myTable">
                                        {this.state.pgViewChargesFillList.length > 0 ? (
                                            this.state.pgViewChargesFillList.map((data, i) => (
                                                <tr key={i}>
                                                    <td className={data.isParent ? 'fw-bold' : ""}>{data.Description}</td>
                                                    <td>{data.Value}</td>
                                                </tr>
                                            ))
                                        ) : (
                                            <>
                                                <tr>
                                                    <td colSpan={6}>No Records Found...</td>
                                                </tr>
                                            </>
                                        )}
                                    </tbody>
                                </table>
                            </> : <></>}

                        </Modal.Body>

                        <Modal.Footer style={{ justifyContent: 'right', padding: '5px 10px' }}>
                            <div class="row">
                                <div class="col-md-12">
                                    {paymentType == 'pending' ?
                                        <button
                                            onClick={() => this.handleSubmit('pending')}
                                            class="btn btn-warning mr-2"
                                            style={{ cursor: 'pointer' }}
                                        >
                                            Yes
                                        </button> :
                                        <>
                                            {paymentType == 'online' && !isIncomplete && (sessionStorage.getItem('isPg') == 1 || sessionStorage.getItem('isPg') == true) ?
                                                <button
                                                    onClick={(e) => this.navPayment(e)}
                                                    class="btn btn-warning mr-2"
                                                    style={{ cursor: 'pointer' }}
                                                >
                                                    I agree & proceed to pay
                                                </button>
                                                :
                                                <button
                                                    onClick={() => this.handleSubmit(paymentType)}
                                                    class="btn btn-warning mr-2"
                                                    style={{ cursor: 'pointer' }}
                                                >
                                                    Yes
                                                </button>
                                            }
                                        </>
                                    }
                                    <button
                                        onClick={() => this.setState({ isOpen2: false })}
                                        class="btn btn-outline-secondary"
                                        style={{ cursor: 'pointer', width: 'auto' }}
                                    >
                                        Back
                                    </button>
                                </div>
                            </div>

                        </Modal.Footer>
                    </Modal>
                    <Modal
                        show={this.state.pgViewChargesModal}
                        onHide={() => this.setState({ pgViewChargesModal: false })}
                        size="xl"
                    >
                        <Modal.Header>
                            <Modal.Title style={{ width: "100%" }}>
                                <h4
                                    className="mb-0 pt-2 thank-top-mes"
                                    style={{ color: "#b6b132ff", textAlign: "center" }}
                                >
                                    <strong style={{ textAlign: "center" }}>
                                        Bank Charges
                                    </strong>
                                </h4>
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <span className="text-danger text-start text-left d-block">
                                Please note that bank charges alongwith GST will be applicable as per selected mode of payment in the next step
                            </span>
                            <table className="table table-bordered table-striped mg-b-0">
                                <thead>
                                    <tr>
                                        <th>Payment Mode</th>
                                        <th>Bank Charges</th>
                                    </tr>
                                </thead>
                                <tbody id="myTable">
                                    {this.state.pgViewChargesFillList.length > 0 ? (
                                        this.state.pgViewChargesFillList.map((data, i) => (
                                            <tr key={i}>
                                                <td className={data.isParent ? 'fw-bold' : ""}>{data.Description}</td>
                                                <td>{data.Value}</td>
                                            </tr>
                                        ))
                                    ) : (
                                        <>
                                            <tr>
                                                <td colSpan={6}>No Records Found...</td>
                                            </tr>
                                        </>
                                    )}
                                </tbody>
                            </table>
                        </Modal.Body>
                        <Modal.Footer>
                            <button
                                type="button"
                                className="btn ad-fil-btn"
                                data-bs-dismiss="modal"
                                style={{ background: "#ddd", color: "#000", padding: "4px 16px" }}
                                onClick={() => this.togglePGCharges()}
                            >
                                OK
                            </button>
                        </Modal.Footer>
                    </Modal>
                    <Footer />
                    <ToastContainer />
                </>
            </>
        );
    }
}
export default withRouter(
    connect(null, {
        getApplicationFormDefaultDetails_action, getApplicationFormDetails_action, insertUpdateApplicationForm_action,
        fill_action, getApplicantPricing_action, sendPaymentForm_action, getApplicationPaymentDetails_action,
        getAwardQuerywithAnswerComment_action, insertUpdateAwardAnswer_action
    })(ApplicationForm)
);
